'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cx = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);

var styles$B = {"layout":"Abbr-module_layout__h50DS","abbr":"Abbr-module_abbr__D7PWn","abbrunstyled":"Abbr-module_abbrunstyled__V5wZq"};

const Abbr = ({
  children,
  className,
  title,
  variants
}) => {
  const modifiers = variants ? variants.map(el => styles$B[`abbr${el}`]) : null;
  const classes = cx__default["default"](styles$B.abbr, modifiers, className, styles$B.layout);
  return /*#__PURE__*/React__namespace.createElement("abbr", {
    className: classes,
    title: title
  }, children);
};

var styles$A = {"copy":"Copy-module_copy__xPF9i","copymax":"Copy-module_copymax__SMjqZ","copyinverted":"Copy-module_copyinverted__Ff5KV","div":"Copy-module_div__m8gTo","p":"Copy-module_p__rAO4T","small":"Copy-module_small__lm8Kr","large":"Copy-module_large__BcmwM","intro":"Copy-module_intro__Ofl9M","left":"Copy-module_left__aT1Pd","right":"Copy-module_right__zMYRx","center":"Copy-module_center__FsDZ1","justify":"Copy-module_justify__I5VqI","nowrap":"Copy-module_nowrap__s9uEQ","lowercase":"Copy-module_lowercase__pUD-S","uppercase":"Copy-module_uppercase__QpUxL","capitalize":"Copy-module_capitalize__U57fO","inverted":"Copy-module_inverted__Zi4DV","muted":"Copy-module_muted__hBmB5"};

const Copy = ({
  children,
  className,
  inverted,
  maxLength,
  tag,
  size,
  align,
  transform,
  contextual
}) => {
  if (!children) return null;
  const classes = cx__default["default"](styles$A.copy, styles$A[tag], {
    [styles$A[size]]: size
  }, {
    [styles$A[align]]: align
  }, {
    [styles$A[transform]]: transform
  }, {
    [styles$A[contextual]]: contextual
  }, {
    [styles$A.copyinverted]: inverted,
    [styles$A.copymax]: maxLength
  }, className);

  if (tag === 'p') {
    return /*#__PURE__*/React__namespace.createElement("p", {
      className: classes
    }, children);
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, children);
};

Copy.defaultProps = {
  inverted: false,
  maxLength: false,
  tag: 'div',
  align: null,
  size: null,
  transform: null,
  contextual: null
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

var fr = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));
});

var es = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));
});

var styles$z = {"time":"Time-module_time__pqHf0"};

const Time = ({
  datetime,
  className,
  format,
  relative,
  noSuffix,
  locale
}) => {
  const classes = cx__default["default"](styles$z.time, className);
  moment.locale(locale, [fr, es]);

  if (relative) {
    const time = moment(datetime).fromNow(noSuffix);
    return /*#__PURE__*/React__namespace.createElement("time", {
      className: classes,
      dateTime: datetime
    }, time);
  }

  const time = moment(datetime).format(format);
  return /*#__PURE__*/React__namespace.createElement("time", {
    className: classes,
    dateTime: datetime
  }, time);
};

Time.defaultProps = {
  format: null,
  noSuffix: false,
  locale: 'en'
};

var styles$y = {"p":"Type-module_p__2hMQy","span":"Type-module_span__GHvgl","label":"Type-module_label__HsAwy","strong":"Type-module_strong__h-leH","em":"Type-module_em__EDVPN","b":"Type-module_b__Gj6vS","i":"Type-module_i__3SsP6","small":"Type-module_small__WFCLO","mark":"Type-module_mark__d-aY8","text":"Type-module_text__tQkg4","text--small":"Type-module_text--small__xcKaL","text--large":"Type-module_text--large__qXBt2","text--intro":"Type-module_text--intro__vPd6D","text--left":"Type-module_text--left__QikTD","text--right":"Type-module_text--right__ewGcT","text--center":"Type-module_text--center__6-QFL","text--justify":"Type-module_text--justify__B5osv","text--nowrap":"Type-module_text--nowrap__XoFic"};

const Type = ({
  children,
  as: Tag,
  className,
  size,
  align
}) => {
  const classes = cx__default["default"](styles$y[Tag], {
    [styles$y[`text--${align}`]]: align
  }, {
    [styles$y[`text--${size}`]]: size
  }, className);
  return /*#__PURE__*/React__namespace.createElement(Tag, {
    className: classes
  }, children);
};

Type.defaultProps = {
  size: null,
  align: 'left',
  as: 'span'
};

var styles$x = {"link":"Link-module_link__kO1x6","link--unstyled":"Link-module_link--unstyled__VmSGo","link--inverted":"Link-module_link--inverted__mdRAd"};

/**
 * Check if event if mouse left click.
 *
 * @param {object} event
 * @returns {bool}
 */

function isLeftClickEvent(event) {
  return event.button === 0;
}
/**
 * Check if event is using a modifier key.
 *
 * @param {object} event
 * @returns {bool}
 */


function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const Link = ({
  href,
  defaultClass,
  children,
  className,
  inverted,
  variants,
  onClick,
  history,
  target
}) => {
  /**
   * Handle onClick.
   *
   * @param {object} event
   */
  const handleClick = event => {
    onClick(event);

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    if (history && href) {
      event.preventDefault();
      history.push(href);
    }
  };

  const modifiers = variants ? variants.map(el => styles$x[`link--${el}`]) : null;
  const classes = cx__default["default"](className, modifiers, {
    [styles$x.link]: defaultClass,
    [styles$x['link--inverted']]: inverted
  });
  return /*#__PURE__*/React__namespace.createElement("a", {
    className: classes,
    href: href,
    onClick: handleClick,
    target: target
  }, children);
};

Link.defaultProps = {
  href: null,
  inverted: null,
  onClick: () => {},
  history: null,
  target: null,
  defaultClass: true,
  variants: null
};

var styles$w = {"heading":"Heading-module_heading__cT9h0","inverted":"Heading-module_inverted__i2-v9","heading--h1":"Heading-module_heading--h1__ZPDty","heading--h2":"Heading-module_heading--h2__OaCN2","heading--h3":"Heading-module_heading--h3__6nhLz","heading--h4":"Heading-module_heading--h4__qzCNA","heading--h5":"Heading-module_heading--h5__BG6Ud","heading--h6":"Heading-module_heading--h6__B0NnU","display":"Heading-module_display__SPHtw","display--themed":"Heading-module_display--themed__rzzWz","display--h1":"Heading-module_display--h1__DCwpS","display--h2":"Heading-module_display--h2__jsgk4","display--h3":"Heading-module_display--h3__-WwDA","display--h4":"Heading-module_display--h4__WCpsh","display--h5":"Heading-module_display--h5__pXY4u","display--h6":"Heading-module_display--h6__vubyj"};

const Heading = ({
  inverted,
  children,
  tag: Tag,
  className,
  type
}) => {
  const classes = cx__default["default"](styles$w[type], className, styles$w[`${type}--${Tag}`], {
    [styles$w.inverted]: inverted
  });
  return /*#__PURE__*/React__namespace.createElement(Tag, {
    className: classes
  }, children);
};

Heading.defaultProps = {
  tag: 'h2',
  className: 'h2',
  inverted: false,
  type: 'heading'
};

var styles$v = {"list":"List-module_list__bGK8-","list--unstyled":"List-module_list--unstyled__NcOyq","list--inline":"List-module_list--inline__A7H4b","list__item":"List-module_list__item__hLHtu","list--small":"List-module_list--small__M9v-1","list--large":"List-module_list--large__x7chw"};

const List = ({
  variants,
  children,
  as: Tag,
  className
}) => {
  const modifiers = variants ? variants.map(el => styles$v[`list--${el}`]) : null;
  const classes = cx__default["default"](styles$v.list, modifiers, className);
  return /*#__PURE__*/React__namespace.createElement(Tag, {
    className: classes
  }, children);
};

List.defaultProps = {
  variants: null,
  as: 'ul'
};

var styles$u = {"dl":"ListItem-module_dl__MJBUJ","dd":"ListItem-module_dd__UJcF7","dt":"ListItem-module_dt__Rgbck"};

const ListItem = ({
  children,
  as: Tag,
  className
}) => {
  const classes = cx__default["default"](className, {
    [styles$u[Tag]]: Tag
  });
  return /*#__PURE__*/React__namespace.createElement(Tag, {
    className: classes
  }, children);
};

ListItem.defaultProps = {
  as: 'li'
};

var styles$t = {"image":"Image-module_image__T1obH","imagefluid":"Image-module_imagefluid__ltDRN","imageresponsive":"Image-module_imageresponsive__1f-lv","imagerounded":"Image-module_imagerounded__kerqT","imagecircle":"Image-module_imagecircle__9MmXT","figure":"Image-module_figure__Y--mt"};

const Image = ({
  src,
  alt,
  className,
  caption,
  figure,
  fluid,
  onLoad
}) => {
  const figureClasses = cx__default["default"](styles$t.figure);
  const classes = cx__default["default"](styles$t.image, className, {
    [styles$t.imagefluid]: fluid
  });
  const renderImg = /*#__PURE__*/React__namespace.createElement("img", {
    onLoad: onLoad,
    src: src,
    alt: alt,
    className: classes
  });
  /**
   * Render as a figure.
   */

  if (figure || caption) {
    return /*#__PURE__*/React__namespace.createElement("figure", {
      className: figureClasses
    }, renderImg, caption && /*#__PURE__*/React__namespace.createElement("figcaption", null, caption));
  }
  /**
   * Default render as an image.
   */


  return renderImg;
};

Image.defaultProps = {
  alt: '',
  caption: null,
  figure: false,
  fluid: false,
  crossOrigin: null,
  onLoad: null
};

var styles$s = {"picture":"ResponsiveImage-module_picture__vhRnb"};

const ResponsiveImage = ({
  className,
  srcSets,
  alt,
  title,
  fallback,
  fluid
}) => {
  const classes = cx__default["default"](styles$s.picture, className);
  const sets = srcSets.map(srcSetsMapped => {
    // `type` is not a required attribute so we add it conditionally.
    const type = srcSetsMapped.type ? {
      type: `${srcSetsMapped.type}`
    } : null;
    return /*#__PURE__*/React__namespace.createElement('source', {
      key: srcSetsMapped.size,
      srcSet: srcSetsMapped.src,
      media: `all and (min-width: ${srcSetsMapped.size})`,
      ...type
    });
  });
  return /*#__PURE__*/React__namespace.createElement("picture", {
    className: classes
  }, sets, /*#__PURE__*/React__namespace.createElement(Image, {
    fluid: fluid,
    src: fallback,
    alt: alt,
    title: title,
    typeof: "foaf:Image"
  }));
};

ResponsiveImage.defaultProps = {
  title: null,
  fluid: false
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var styles$r = {"formItem":"FormInput-module_formItem__x4VXl","formItemRequired":"FormInput-module_formItemRequired__rzMwx","formItem__label":"FormInput-module_formItem__label__tu-Yg","formItem__input":"FormInput-module_formItem__input__x8QoM","formItem__inputtext":"FormInput-module_formItem__inputtext__5zjJy","is-disabled":"FormInput-module_is-disabled__FMsgJ","formItem__inputemail":"FormInput-module_formItem__inputemail__ngdNa","formItem__inputurl":"FormInput-module_formItem__inputurl__AYgVA","formItem__inputpassword":"FormInput-module_formItem__inputpassword__MeWqD","formItem__inputsearch":"FormInput-module_formItem__inputsearch__50X6x","formItem__inputfile":"FormInput-module_formItem__inputfile__x0eDr","formItem__inputdate":"FormInput-module_formItem__inputdate__0ujzb","formItem__inputnumber":"FormInput-module_formItem__inputnumber__I-ofC","formItem__inputdatetime":"FormInput-module_formItem__inputdatetime__aLs1p","formItem__inputdatetime-local":"FormInput-module_formItem__inputdatetime-local__hfMQi","formItem__inputmonth":"FormInput-module_formItem__inputmonth__wmhG0","formItem__inputtime":"FormInput-module_formItem__inputtime__ZYD9I","formItem__inputweek":"FormInput-module_formItem__inputweek__59XLf","formItem__inputnewsletter":"FormInput-module_formItem__inputnewsletter__S5rGr","formItem__inputtextarea":"FormInput-module_formItem__inputtextarea__8M6-g","formItemOptional":"FormInput-module_formItemOptional__eBes4"};

const FormInput = ({
  id,
  type,
  required,
  className,
  label,
  labelClasses,
  labelInverse,
  requiredIndicator,
  strings,
  onChange,
  placeholder,
  ...props
}) => {
  const inputRef = React__namespace.useRef();
  React__namespace.useEffect(() => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line global-require
      require('date-input-polyfill');
    }
  }, []);
  const classes = cx__default["default"](className, styles$r.formItem, styles$r.formItem__input, styles$r[`formItem__input${type}`], {
    [styles$r.formItemRequired]: required
  });
  const labelClassesCX = cx__default["default"]({
    [styles$r.formItem__label]: label
  }, {
    'is-required': required
  }, labelClasses);
  /**
   * Composes a label suffix for required labels.
   */

  const labelSuffix = (() => {
    if (required) {
      return /*#__PURE__*/React__namespace.createElement("span", null, /*#__PURE__*/React__namespace.createElement("span", {
        "aria-hidden": "true",
        className: cx__default["default"](styles$r.formItemRequired)
      }, requiredIndicator), /*#__PURE__*/React__namespace.createElement("span", {
        className: "sr-only"
      }, strings === null || strings === void 0 ? void 0 : strings.requiredText));
    }

    return /*#__PURE__*/React__namespace.createElement("span", {
      className: cx__default["default"]('sr-only', styles$r.formItemOptional)
    }, "\xA0", strings === null || strings === void 0 ? void 0 : strings.optionalText);
  })();

  const format = 'dd/mm/yyyy';
  const placeholderSet = type === 'date' ? format.toUpperCase() : placeholder;
  const dateFormat = type === 'date' ? format : null;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, !labelInverse && /*#__PURE__*/React__namespace.createElement("label", {
    className: labelClassesCX,
    htmlFor: id
  }, label, labelSuffix), /*#__PURE__*/React__namespace.createElement("input", _extends$1({
    ref: inputRef,
    id: id,
    className: classes,
    type: type,
    required: required,
    "aria-required": required,
    placeholder: placeholderSet,
    "date-format": dateFormat,
    onChange: onChange // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)), labelInverse && /*#__PURE__*/React__namespace.createElement("label", {
    className: labelClassesCX,
    htmlFor: id
  }, label, labelSuffix));
};

FormInput.defaultProps = {
  required: false,
  requiredIndicator: '*',
  strings: {
    requiredText: 'This field is required',
    optionalText: 'Optional'
  },
  label: null,
  placeholder: null,
  labelInverse: false,
  labelClasses: null
};

var styles$q = {"formItemRequired":"FormTextArea-module_formItemRequired__3SL3U","formItem__label":"FormTextArea-module_formItem__label__g4uc6","formItem__textArea":"FormTextArea-module_formItem__textArea__Lx6rF","is-disabled":"FormTextArea-module_is-disabled__OocMk","formItemrequired":"FormTextArea-module_formItemrequired__4M-hF"};

const FormTextArea = ({
  input,
  id,
  required,
  className,
  defaultValue,
  label,
  labelClasses,
  onChange,
  placeholder
}) => {
  const inputRef = React__namespace.useRef();
  const classes = cx__default["default"](styles$q.formItem__textArea, className);
  const labelClassesCX = cx__default["default"]({
    [styles$q.formItem__label]: label
  }, {
    'is-required': required
  }, labelClasses);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, label && /*#__PURE__*/React__namespace.createElement("label", {
    className: labelClassesCX,
    htmlFor: id
  }, label), /*#__PURE__*/React__namespace.createElement("textarea", {
    ref: inputRef,
    id: id,
    className: classes,
    input: input,
    required: required,
    "aria-required": required,
    onChange: onChange,
    placeholder: placeholder,
    defaultValue: defaultValue
  }));
};

FormTextArea.defaultProps = {
  input: null,
  required: false,
  defaultValue: null,
  label: null,
  labelClasses: null,
  placeholder: null
};

/*!
 * html-attributes
 * https://github.com/alexmingoia/html-attributes
 */

/**
 * @module html-attributes
 */

var htmlAttributes = {
  "abbr": "abbr",
  "accept": "accept",
  "acceptCharset": "accept-charset",
  "accessKey": "accesskey",
  "action": "action",
  "allowFullScreen": "allowfullscreen",
  "allowTransparency": "allowtransparency",
  "alt": "alt",
  "async": "async",
  "autoComplete": "autocomplete",
  "autoFocus": "autofocus",
  "autoPlay": "autoplay",
  "cellPadding": "cellpadding",
  "cellSpacing": "cellspacing",
  "challenge": "challenge",
  "charset": "charset",
  "checked": "checked",
  "cite": "cite",
  "class": "class",
  "className": "class",
  "cols": "cols",
  "colSpan": "colspan",
  "command": "command",
  "content": "content",
  "contentEditable": "contenteditable",
  "contextMenu": "contextmenu",
  "controls": "controls",
  "coords": "coords",
  "crossOrigin": "crossorigin",
  "data": "data",
  "dateTime": "datetime",
  "default": "default",
  "defer": "defer",
  "dir": "dir",
  "disabled": "disabled",
  "download": "download",
  "draggable": "draggable",
  "dropzone": "dropzone",
  "encType": "enctype",
  "for": "for",
  "form": "form",
  "formAction": "formaction",
  "formEncType": "formenctype",
  "formMethod": "formmethod",
  "formNoValidate": "formnovalidate",
  "formTarget": "formtarget",
  "frameBorder": "frameBorder",
  "headers": "headers",
  "height": "height",
  "hidden": "hidden",
  "high": "high",
  "href": "href",
  "hrefLang": "hreflang",
  "htmlFor": "for",
  "httpEquiv": "http-equiv",
  "icon": "icon",
  "id": "id",
  "inputMode": "inputmode",
  "isMap": "ismap",
  "itemId": "itemid",
  "itemProp": "itemprop",
  "itemRef": "itemref",
  "itemScope": "itemscope",
  "itemType": "itemtype",
  "kind": "kind",
  "label": "label",
  "lang": "lang",
  "list": "list",
  "loop": "loop",
  "manifest": "manifest",
  "max": "max",
  "maxLength": "maxlength",
  "media": "media",
  "mediaGroup": "mediagroup",
  "method": "method",
  "min": "min",
  "minLength": "minlength",
  "multiple": "multiple",
  "muted": "muted",
  "name": "name",
  "noValidate": "novalidate",
  "open": "open",
  "optimum": "optimum",
  "pattern": "pattern",
  "ping": "ping",
  "placeholder": "placeholder",
  "poster": "poster",
  "preload": "preload",
  "radioGroup": "radiogroup",
  "readOnly": "readonly",
  "rel": "rel",
  "required": "required",
  "role": "role",
  "rows": "rows",
  "rowSpan": "rowspan",
  "sandbox": "sandbox",
  "scope": "scope",
  "scoped": "scoped",
  "scrolling": "scrolling",
  "seamless": "seamless",
  "selected": "selected",
  "shape": "shape",
  "size": "size",
  "sizes": "sizes",
  "sortable": "sortable",
  "span": "span",
  "spellCheck": "spellcheck",
  "src": "src",
  "srcDoc": "srcdoc",
  "srcSet": "srcset",
  "start": "start",
  "step": "step",
  "style": "style",
  "tabIndex": "tabindex",
  "target": "target",
  "title": "title",
  "translate": "translate",
  "type": "type",
  "typeMustMatch": "typemustmatch",
  "useMap": "usemap",
  "value": "value",
  "width": "width",
  "wmode": "wmode",
  "wrap": "wrap"
};

var dist = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = filterInvalidDOMProps;



var _htmlAttributes2 = _interopRequireDefault(htmlAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventProps = {
	onCopy: true,
	onCut: true,
	onPaste: true,
	onLoad: true,
	onError: true,
	onWheel: true,
	onScroll: true,
	onCompositionEnd: true,
	onCompositionStart: true,
	onCompositionUpdate: true,
	onKeyDown: true,
	onKeyPress: true,
	onKeyUp: true,
	onFocus: true,
	onBlur: true,
	onChange: true,
	onInput: true,
	onSubmit: true,
	onClick: true,
	onContextMenu: true,
	onDoubleClick: true,
	onDrag: true,
	onDragEnd: true,
	onDragEnter: true,
	onDragExit: true,
	onDragLeave: true,
	onDragOver: true,
	onDragStart: true,
	onDrop: true,
	onMouseDown: true,
	onMouseEnter: true,
	onMouseLeave: true,
	onMouseMove: true,
	onMouseOut: true,
	onMouseOver: true,
	onMouseUp: true,
	onSelect: true,
	onTouchCancel: true,
	onTouchEnd: true,
	onTouchMove: true,
	onTouchStart: true,
	onAnimationStart: true,
	onAnimationEnd: true,
	onAnimationIteration: true,
	onTransitionEnd: true
};

function isValidDOMProp(prop) {
	return eventProps[prop] || _htmlAttributes2.default[prop] || /^(data|aria)-/.test(prop);
}

function filterInvalidDOMProps(props) {
	var domProps = {};
	for (var prop in props) {
		if (props.hasOwnProperty(prop) && isValidDOMProp(prop)) {
			domProps[prop] = props[prop];
		}
	}
	return domProps;
}
});

var filterInvalidDOMProps = unwrapExports(dist);

var styles$p = {"icon":"Icon-module_icon__jtajZ","iconsize":"Icon-module_iconsize__XReGU"};

const Icon = ({
  className,
  color,
  path,
  size,
  title
}) => {
  const classes = cx__default["default"](styles$p.icon, className);
  return /*#__PURE__*/React__namespace.createElement("svg", {
    className: classes,
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, title && /*#__PURE__*/React__namespace.createElement("title", {
    id: "title"
  }, title), /*#__PURE__*/React__namespace.createElement("path", {
    style: {
      fill: color
    },
    d: path
  }));
};

Icon.defaultProps = {
  color: null,
  size: 24,
  title: null
};

/**
 * Helper function for setting up SVG Icon.
 *
 * @param {string} path
 * @param {Object} props
 */

function createSvgIcon(path, props = {}) {
  const svgPath = path.props && path.props.d ? path.props.d : path;

  const svgIcon = () => /*#__PURE__*/React__default["default"].createElement(Icon, _extends$1({
    path: svgPath
  }, props));

  return svgIcon;
}

const ChevronDown = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

var styles$o = {"formselect":"FormSelect-module_formselect__02rTI","is-disabled":"FormSelect-module_is-disabled__U---w","formselectarrow":"FormSelect-module_formselectarrow__MIzxN","select":"FormSelect-module_select__c8wEk"};

const FormSelect = ({
  selectIcon: SelectIcon,
  input,
  id,
  options,
  required,
  className,
  iconColor,
  wrapperStyles,
  ...select
}) => {
  const req = required ? {
    required: true,
    'aria-required': 'true'
  } : null;
  const filteredProps = filterInvalidDOMProps(select);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: cx__default["default"](styles$o.formselect, wrapperStyles)
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: cx__default["default"](styles$o.formselectarrow)
  }, SelectIcon ? /*#__PURE__*/React__namespace.createElement(SelectIcon, {
    color: iconColor
  }) : /*#__PURE__*/React__namespace.createElement(ChevronDown, {
    color: iconColor
  })), /*#__PURE__*/React__namespace.createElement("select", _extends$1({}, filteredProps, {
    id: id
  }, req, {
    className: cx__default["default"](styles$o.select, className)
  }), options && options.map(({
    value,
    label: optionLabel,
    ...rest
  }) => /*#__PURE__*/React__namespace.createElement("option", _extends$1({
    key: value,
    value: value
  }, input, rest), optionLabel))));
};

FormSelect.defaultProps = {
  selectIcon: null,
  select: null,
  required: false,
  input: null,
  iconColor: '#000',
  wrapperStyles: null
};

var styles$n = {"btn":"Button-module_btn__1vDEO","icon":"Button-module_icon__GrcZ6","btn--link":"Button-module_btn--link__eWasl","btn--link-secondary":"Button-module_btn--link-secondary__u0t1j","focus":"Button-module_focus__yjbnB","active":"Button-module_active__Ikiar","disabled":"Button-module_disabled__cF4iq","btn-icon":"Button-module_btn-icon__6cYYw","icon-ends-icon":"Button-module_icon-ends-icon__y-uqz","icon-start-icon":"Button-module_icon-start-icon__P9p30","icon-end-icon":"Button-module_icon-end-icon__DS8X-","icon-both-icon":"Button-module_icon-both-icon__7Xuxp","btn--default":"Button-module_btn--default__5WHhx","is-active":"Button-module_is-active__hEPJe","btn--inverted":"Button-module_btn--inverted__KZK-Z","btn--outline":"Button-module_btn--outline__TWfw-","btn--primary":"Button-module_btn--primary__SrsPP","btn--secondary":"Button-module_btn--secondary__fShsV","btn--tertiary":"Button-module_btn--tertiary__2IT-q","btn--success":"Button-module_btn--success__aXNrf","btn--info":"Button-module_btn--info__fxUEW","btn--warning":"Button-module_btn--warning__mTTub","btn--danger":"Button-module_btn--danger__UiLNI","btn--small":"Button-module_btn--small__TOjQD","btn--large":"Button-module_btn--large__oC2Kd","btn--fill-gradient-alpha":"Button-module_btn--fill-gradient-alpha__TzAwe","btn--fill-gradient-beta":"Button-module_btn--fill-gradient-beta__JbKk5","btn--fill-gradient-gamma":"Button-module_btn--fill-gradient-gamma__gztr1","btn--fill-gradient-delta":"Button-module_btn--fill-gradient-delta__-0eT-","btn--fill-gradient-epsilon":"Button-module_btn--fill-gradient-epsilon__G5WRV","btn--fill-gradient-zeta":"Button-module_btn--fill-gradient-zeta__M2Juz","btn--fill-gradient-eta":"Button-module_btn--fill-gradient-eta__RQFRm","btn--fill-gradient-theta":"Button-module_btn--fill-gradient-theta__4a-jZ","btn--fill-gradient-iota":"Button-module_btn--fill-gradient-iota__8GiGo","btn--fill-gradient-kappa":"Button-module_btn--fill-gradient-kappa__o6Ddx","btn--fill-gradient-lambda":"Button-module_btn--fill-gradient-lambda__IQlfh","btn--fill-gradient-mu":"Button-module_btn--fill-gradient-mu__grUOe","btn--fill-gradient-nu":"Button-module_btn--fill-gradient-nu__su0Sz","btn--fill-gradient-xi":"Button-module_btn--fill-gradient-xi__KJD-l","btn--fill-gradient-omicron":"Button-module_btn--fill-gradient-omicron__N0As1","btn--fill-gradient--pi":"Button-module_btn--fill-gradient--pi__1-qYS","btn--fill-gradient-secondary-alpha":"Button-module_btn--fill-gradient-secondary-alpha__7nOpb","btn--fill-gradient-secondary-beta":"Button-module_btn--fill-gradient-secondary-beta__ZMV3g","btn--fill-gradient-secondary-gamma":"Button-module_btn--fill-gradient-secondary-gamma__iSlY-","btn--fill-gradient-secondary-delta":"Button-module_btn--fill-gradient-secondary-delta__gis--","btn--fill-gradient-secondary-epsilon":"Button-module_btn--fill-gradient-secondary-epsilon__i0s9m","btn--fill-gradient-secondary-zeta":"Button-module_btn--fill-gradient-secondary-zeta__dPuzm","btn--fill-gradient-secondary-eta":"Button-module_btn--fill-gradient-secondary-eta__JDFAX","btn--fill-gradient-secondary-theta":"Button-module_btn--fill-gradient-secondary-theta__MSCiN","btn--fill-gradient-secondary-iota":"Button-module_btn--fill-gradient-secondary-iota__n2DKt","btn--fill-gradient-secondary-kappa":"Button-module_btn--fill-gradient-secondary-kappa__u2Jwo","btn--fill-gradient-secondary-lambda":"Button-module_btn--fill-gradient-secondary-lambda__0zCXZ","btn--fill-gradient-secondary-mu":"Button-module_btn--fill-gradient-secondary-mu__5uYD9","btn--fill-gradient-secondary-nu":"Button-module_btn--fill-gradient-secondary-nu__A-a96","btn--fill-gradient-secondary-xi":"Button-module_btn--fill-gradient-secondary-xi__Q1eCo","btn--fill-gradient-secondary-omicron":"Button-module_btn--fill-gradient-secondary-omicron__VPzAg","btn--fill-gradient-secondary-pi":"Button-module_btn--fill-gradient-secondary-pi__XZb7-","btn--round":"Button-module_btn--round__uyR82","round-icon":"Button-module_round-icon__ZNUCt","btn--block":"Button-module_btn--block__e1Hz0"};

/* eslint-enable no-unused-vars */


const Button = ({
  onClick,
  href,
  tag,
  variants,
  className,
  icon: Icon,
  text,
  id,
  type,
  disabled,
  ariaLabel,
  target
}) => {
  const modifiers = variants.map(el => styles$n[`btn--${el}`]);
  const classes = cx__default["default"](styles$n.btn, modifiers, className);
  const iconModifiers = variants.map(el => styles$n[`${el}-icon`]);
  const iconClassName = iconModifiers.filter(Boolean)[0];
  const StyledIcon = Icon ? /*#__PURE__*/React__namespace.cloneElement(Icon, {
    className: iconClassName
  }, null) : Icon;
  const render = variants.includes('icon-ends') ? /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, text, Icon && /*#__PURE__*/React__namespace.createElement("span", null, StyledIcon)) : /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, Icon && /*#__PURE__*/React__namespace.createElement("span", null, StyledIcon), text);

  if (tag === 'link') {
    return /*#__PURE__*/React__namespace.createElement(Link, {
      onClick: onClick,
      href: href,
      className: classes,
      target: target
    }, render);
  }

  return (
    /*#__PURE__*/

    /* eslint-disable react/button-has-type */
    React__namespace.createElement("button", {
      id: id,
      onClick: onClick,
      className: classes,
      type: type,
      disabled: disabled,
      "aria-label": ariaLabel,
      role: "button"
    }, render)
  );
};

Button.defaultProps = {
  variants: ['default'],
  href: null,
  tag: 'button',
  onClick: null,
  icon: null,
  text: null,
  type: 'button',
  disabled: false,
  ariaLabel: null
};

var styles$m = {"btnGroup":"ButtonGroup-module_btnGroup__pjf4j"};

const ButtonGroup = ({
  children,
  className
}) => {
  const classes = cx__default["default"](styles$m.btnGroup, className);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, children);
};

ButtonGroup.defaultProps = {
  className: ''
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

var styles$l = {"form":"Form-module_form__Yk9Kd"};

const Form = ({
  children,
  className,
  noValidate,
  submit,
  onSubmit,
  hideSubmit,
  ariaSubmitLabel,
  submitID
}) => {
  const submitClasses = cx__default["default"]({
    'sr-only': hideSubmit
  });
  const classes = cx__default["default"](styles$l.form, className);
  return /*#__PURE__*/React__namespace.createElement("form", {
    className: classes,
    onSubmit: onSubmit,
    noValidate: noValidate
  }, children, /*#__PURE__*/React__namespace.createElement(Button, {
    className: submitClasses,
    ariaLabel: ariaSubmitLabel,
    id: `${submitID}-${v4()}`,
    title: submit,
    type: "submit",
    tag: "button",
    text: submit,
    variants: ['primary']
  }));
};

Form.defaultProps = {
  children: null,
  className: 'form',
  noValidate: false,
  submit: 'Submit',
  hideSubmit: false,
  ariaSubmitLabel: null
};

const EyeoffOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const EyeOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

var styles$k = {"form-item__input--text":"FormField-module_form-item__input--text__d3--O","is-disabled":"FormField-module_is-disabled__TKUAx","form-item__input--email":"FormField-module_form-item__input--email__2l3dp","form-item__input--url":"FormField-module_form-item__input--url__SVRSY","form-item__input--password":"FormField-module_form-item__input--password__A688l","form-item__input--search":"FormField-module_form-item__input--search__P1lGH","form-item__input--file":"FormField-module_form-item__input--file__0CdbG","form-item__input--date":"FormField-module_form-item__input--date__npLAq","form-item__input--number":"FormField-module_form-item__input--number__ULLNi","form-item__input--datetime":"FormField-module_form-item__input--datetime__b9UzM","form-item__input--datetime-local":"FormField-module_form-item__input--datetime-local__ZmBn-","form-item__input--month":"FormField-module_form-item__input--month__EuaiW","form-item__input--time":"FormField-module_form-item__input--time__UWRUv","form-item__input--week":"FormField-module_form-item__input--week__F7LPz","form-item__input--newsletter":"FormField-module_form-item__input--newsletter__dO2oy","form-item__textarea":"FormField-module_form-item__textarea__uvkis","form-item__select":"FormField-module_form-item__select__kR4tz","form-item":"FormField-module_form-item__QSUYV","form-item__label":"FormField-module_form-item__label__yNwbA","form-item__input":"FormField-module_form-item__input__wNBSx","form-item__input-wrapper":"FormField-module_form-item__input-wrapper__LtPh0","form-item__input-helper":"FormField-module_form-item__input-helper__eMM46","icon":"FormField-module_icon__ehp1B","form-item__input--textarea":"FormField-module_form-item__input--textarea__HUA8i","form-item__required":"FormField-module_form-item__required__cwirt","form-item__optional":"FormField-module_form-item__optional__RI80v","form-item__checkbox":"FormField-module_form-item__checkbox__zjm30","form-item__radio":"FormField-module_form-item__radio__TMNXG","form-item__message":"FormField-module_form-item__message__8HX-T","form-item__description":"FormField-module_form-item__description__El7Yt","form-item--error":"FormField-module_form-item--error__c-vk-","form-item--password":"FormField-module_form-item--password__vOHf-","radioWrapper":"FormField-module_radioWrapper__SRd4t"};

const FormField = ({
  id,
  label,
  type,
  options,
  meta,
  strings,
  labelClasses,
  description,
  className,
  required,
  passwordShow,
  onChange,
  placeholder,
  input,
  name
}) => {
  const [passwordShowStatus, setPasswordShow] = React__namespace.useState(passwordShow);
  const {
    touched,
    error,
    warning
  } = meta || {};
  /**
   * Handles toggling the state of the password field visibility.
   */

  const toggleShowPassword = () => setPasswordShow(pS => !pS);
  /**
   * Checks if the keyboard event should trigger an action.
   *
   * @param {event} event - Keyboard event.
   * @memberof FormField
   */


  const checkKeycode = event => {
    event.stopPropagation();

    if (event.keyCode === 13) {
      toggleShowPassword();
    }
  }; // Password field setup.


  let fieldType = type;

  if (type === 'password') {
    fieldType = passwordShow ? 'text' : 'password';
  } // Input type class setup.


  const formItem = styles$k['form-item'];
  const classes = cx__default["default"](formItem, className, {
    [styles$k['form-item--error']]: touched && error
  }, {
    [styles$k['form-item--password']]: type === 'password'
  }); // Check input type to assign correct layout and correct input class.

  let inputClass = '';
  let labelInverse = false;

  switch (type) {
    case 'checkbox':
      inputClass = 'checkbox';
      labelInverse = true;
      break;

    case 'radio':
      inputClass = 'radio';
      labelInverse = true;
      break;

    case 'select':
      inputClass = 'select';
      break;

    default:
      {
        inputClass = 'input';
      }
  }

  const inputClasses = cx__default["default"](styles$k[`form-item__${inputClass}`], styles$k[`form-item__input--${type}`]);
  const {
    showPasswordLabel,
    hidePasswordLabel
  } = strings; // Render input field as `select` or `input`.

  let renderInput = '';

  switch (type) {
    case 'select':
      {
        renderInput = /*#__PURE__*/React__namespace.createElement(FormSelect, _extends$1({
          label: label,
          labelClasses: labelClasses,
          labelInverse: labelInverse,
          id: id,
          options: options,
          required: required,
          onChange: onChange // eslint-disable-next-line react/jsx-props-no-spreading

        }, input));
        break;
      }

    case 'radio':
      {
        renderInput = /*#__PURE__*/React__namespace.createElement(FormInput, _extends$1({
          className: inputClasses,
          labelClasses: labelClasses,
          labelInverse: labelInverse,
          type: fieldType,
          required: required,
          onChange: onChange,
          id: id,
          label: label,
          name: name // eslint-disable-next-line react/jsx-props-no-spreading

        }, input));
      }
      break;

    case 'textarea':
      {
        renderInput = /*#__PURE__*/React__namespace.createElement(FormTextArea, _extends$1({
          className: inputClasses,
          id: id,
          required: required,
          placeholder: placeholder,
          onChange: onChange,
          label: label,
          labelClasses: labelClasses // eslint-disable-next-line react/jsx-props-no-spreading

        }, input));
        break;
      }

    case 'password':
      {
        const toggleType = passwordShowStatus ? 'text' : 'password';
        renderInput = /*#__PURE__*/React__namespace.createElement("div", {
          className: styles$k['form-item__input-wrapper']
        }, /*#__PURE__*/React__namespace.createElement("span", {
          className: styles$k['form-item__input-helper'],
          onClick: toggleShowPassword,
          onKeyDown: checkKeycode,
          role: "button",
          tabIndex: "0"
        }, passwordShowStatus ? /*#__PURE__*/React__namespace.createElement("button", {
          type: "button",
          "aria-label": hidePasswordLabel
        }, /*#__PURE__*/React__namespace.createElement(EyeoffOutline, {
          size: 24
        })) : /*#__PURE__*/React__namespace.createElement("button", {
          type: "button",
          "aria-label": showPasswordLabel
        }, /*#__PURE__*/React__namespace.createElement(EyeOutline, {
          size: 24
        }))), /*#__PURE__*/React__namespace.createElement(FormInput, _extends$1({
          className: inputClasses,
          id: id,
          type: toggleType,
          required: required,
          label: label,
          labelClasses: labelClasses,
          labelInverse: labelInverse,
          onChange: onChange // eslint-disable-next-line react/jsx-props-no-spreading

        }, input)));
        break;
      }

    default:
      {
        renderInput = /*#__PURE__*/React__namespace.createElement(FormInput, _extends$1({
          className: inputClasses,
          id: id,
          type: fieldType,
          required: required,
          placeholder: placeholder,
          label: label,
          labelClasses: labelClasses,
          labelInverse: labelInverse,
          onChange: onChange // eslint-disable-next-line react/jsx-props-no-spreading

        }, input));
      }
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, renderInput, touched && error && /*#__PURE__*/React__namespace.createElement("span", {
    className: cx__default["default"](styles$k['form-item__message'])
  }, error), touched && warning && /*#__PURE__*/React__namespace.createElement("span", {
    className: cx__default["default"](styles$k['form-item__message'])
  }, warning), description && /*#__PURE__*/React__namespace.createElement("span", {
    className: cx__default["default"](styles$k['form-item__description'])
  }, description));
};

FormField.defaultProps = {
  type: 'text',
  options: null,
  required: false,
  description: null,
  strings: {
    showPasswordLabel: 'Show password',
    hidePasswordLabel: 'Hide password'
  },
  labelClasses: null,
  passwordShow: false,
  placeholder: null,

  /** Redux-Form/React-Final-Form actions. */
  input: null,
  onChange: null,
  name: null
};

var styles$j = {"cardContent":"CardContent-module_cardContent__VEn9q","cardContent--flush":"CardContent-module_cardContent--flush__2gJ2O","cardContent--narrow":"CardContent-module_cardContent--narrow__ymm9A"};

const CardContent = ({
  children,
  className,
  modifier
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"](styles$j.cardContent, className, {
    [styles$j[`cardContent--${modifier}`]]: modifier
  })
}, children);

CardContent.defaultProps = {
  modifier: null
};
CardContent.displayName = 'Card.Content';

var styles$i = {"cardFooter":"CardFooter-module_cardFooter__gHdhd","cardFooter--flush":"CardFooter-module_cardFooter--flush__rxXI6","cardFooter--narrow":"CardFooter-module_cardFooter--narrow__LXgXH","cardFooter--cols--1":"CardFooter-module_cardFooter--cols--1__-kXYc","cardFooter--cols--2":"CardFooter-module_cardFooter--cols--2__Xor-B","cardFooter--cols--3":"CardFooter-module_cardFooter--cols--3__uFPRf","cardFooter--cols--4":"CardFooter-module_cardFooter--cols--4__j4s5U"};

const CardFooter = ({
  children,
  className,
  modifier,
  cols
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"](styles$i.cardFooter, className, styles$i[`cardFooter--cols--${cols}`], {
    [styles$i[`cardFooter--${modifier}`]]: modifier
  })
}, children);

CardFooter.defaultProps = {
  cols: 1
};
CardFooter.displayName = 'Card.Footer';

var styles$h = {"cardheader":"CardHeader-module_cardheader__-wD2p"};

const CardHeader = ({
  children,
  className
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"](styles$h.cardheader, className)
}, children);

CardHeader.displayName = 'Card.Header';

/**
 * Creates a classname from a class-unfriendly string.
 *
 * @param {string} string
 * @returns {string}
 */
const createClassname = string => {
  if (typeof string !== 'string') return null;
  /* eslint-disable no-useless-escape. */

  return string.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~]/g, '').toLowerCase().split(' ').join('-');
};

var styles$g = {"ratio":"AspectRatio-module_ratio__rAxVG","ratio--1-1":"AspectRatio-module_ratio--1-1__pRs9D","ratio--1-2":"AspectRatio-module_ratio--1-2__pceht","ratio--2-1":"AspectRatio-module_ratio--2-1__-XEOe","ratio--2-3":"AspectRatio-module_ratio--2-3__aJlC-","ratio--3-4":"AspectRatio-module_ratio--3-4__1tC4k","ratio--4-3":"AspectRatio-module_ratio--4-3__hVRHT","ratio--9-16":"AspectRatio-module_ratio--9-16__c3kKf","ratio--16-9":"AspectRatio-module_ratio--16-9__8GDN1","ratioplaceholder":"AspectRatio-module_ratioplaceholder__9bPDJ"};

const AspectRatio = ({
  className,
  children,
  placeholder,
  ratio
}) => {
  const ratioClassName = createClassname(ratio.replace('/', '-'));
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: cx__default["default"](styles$g.ratio, styles$g[`ratio--${ratioClassName}`], className)
  }, placeholder && /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$g.ratioplaceholder,
    role: "presentation"
  }, placeholder), children);
};

AspectRatio.defaultProps = {
  placeholder: null,
  ratio: '1/1',
  className: ''
};

var styles$f = {"cardMedia":"CardMedia-module_cardMedia__z-j-d"};

const CardMedia = ({
  className,
  src,
  srcSets,
  alt,
  title,
  aspectRatio,
  children
}) => {
  const classes = cx__default["default"](styles$f.cardMedia, className);

  if (srcSets) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      className: classes
    }, /*#__PURE__*/React__namespace.createElement(ResponsiveImage, {
      srcSets: srcSets,
      fallback: src,
      alt: alt,
      title: title
    }), children);
  }

  if (aspectRatio) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      className: classes
    }, /*#__PURE__*/React__namespace.createElement(AspectRatio, {
      ratio: aspectRatio
    }, /*#__PURE__*/React__namespace.createElement(Image, {
      src: src,
      alt: alt,
      title: title
    })), children);
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__namespace.createElement(Image, {
    src: src,
    alt: alt,
    title: title
  }), children);
};

CardMedia.defaultProps = {
  srcSets: null,
  title: '',
  aspectRatio: null
};
CardMedia.displayName = 'Card.Media';

var styles$e = {"card-placeholder--alpha":"CardPlaceholder-module_card-placeholder--alpha__r3Lhy","card-placeholder--alphawide":"CardPlaceholder-module_card-placeholder--alphawide__4Fs9L","card-placeholder--alphanarrow":"CardPlaceholder-module_card-placeholder--alphanarrow__qIb-O","card-placeholder--alphaanimated":"CardPlaceholder-module_card-placeholder--alphaanimated__Rio-i","pulse":"CardPlaceholder-module_pulse__J4Xi8"};

const CardPlaceholder = ({
  className,
  aspectRatio,
  type,
  rows,
  animated
}) => {
  const placeHolderClass = cx__default["default"](styles$e[`card-placeholder--${type}`], {
    [styles$e[`card-placeholder--${type}--animated`]]: animated
  });
  const rowsRender = rows.map((mod, index) => /*#__PURE__*/React__namespace.createElement("div", {
    key: `${type}-${mod}--${index}`,
    className: cx__default["default"](styles$e[`card-placeholder--${type}`], styles$e[`card-placeholder--${type}--${mod}`], {
      [styles$e[`card-placeholder--${type}--animated`]]: animated
    })
  }));
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className
  }, /*#__PURE__*/React__namespace.createElement(AspectRatio, {
    ratio: aspectRatio
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: placeHolderClass
  })), /*#__PURE__*/React__namespace.createElement("div", null, rowsRender));
};

CardPlaceholder.defaultProps = {
  aspectRatio: '2/3',
  type: 'alpha',
  rows: ['wide', 'narrow'],
  animated: false
};
CardPlaceholder.displayName = 'Card.Placeholder';

var styles$d = {"cardTitle":"CardTitle-module_cardTitle__1McwD","cardTitle--flush":"CardTitle-module_cardTitle--flush__FysCa","cardTitle--narrow":"CardTitle-module_cardTitle--narrow__s-lYl"};

const CardTitle = ({
  title,
  tag: Tag,
  className,
  titleClassName,
  modifier,
  headingType
}) => {
  const classes = cx__default["default"](styles$d.cardTitle, className, {
    [styles$d[`cardTitle--${modifier}`]]: modifier
  });
  const tagType = Tag.toLowerCase();
  const headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  return headings.includes(tagType) ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__namespace.createElement(Heading, {
    tag: tagType,
    className: titleClassName,
    type: headingType
  }, title)) : /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__namespace.createElement(Tag, {
    className: titleClassName
  }, title));
};

CardTitle.defaultProps = {
  /** Useful to extend the style applied to components. */

  /** HTML element to output. */
  tag: 'div',

  /** Useful to extend the style applied to components tag. */
  titleClassName: null
};
CardTitle.displayName = 'Card.Title';

var styles$c = {"cardFlag":"CardFlag-module_cardFlag__xUOeH","cardFlag--primary":"CardFlag-module_cardFlag--primary__gAr0g","cardFlag--secondary":"CardFlag-module_cardFlag--secondary__E--Qr","cardFlag--upperLeft":"CardFlag-module_cardFlag--upperLeft__b7Sei","cardFlag--upperRight":"CardFlag-module_cardFlag--upperRight__MW9Mz","cardFlag--lowerLeft":"CardFlag-module_cardFlag--lowerLeft__NevX-","cardFlag--lowerRight":"CardFlag-module_cardFlag--lowerRight__9cxVD"};

const CardFlag = ({
  children,
  className,
  type,
  position
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"](styles$c.cardFlag, className, {
    [styles$c[`cardFlag--${type}`]]: type
  }, {
    [styles$c[`cardFlag--${position}`]]: position
  })
}, children);

CardFlag.defaultProps = {
  type: 'primary',
  position: 'upperLeft'
};
CardFlag.displayName = 'Card.Flag';

var styles$b = {"card":"Card-module_card__1C11I","card--column":"Card-module_card--column__xdOCI","card--row":"Card-module_card--row__PXdYh","card--row--sm":"Card-module_card--row--sm__NCfTw","card--default":"Card-module_card--default__-ASCP","card--small":"Card-module_card--small__-yITS","card--large":"Card-module_card--large__k--x7","card--framed":"Card-module_card--framed__e-Hgv","card--raised":"Card-module_card--raised__RGg2z","text--left":"Card-module_text--left__fZSjn","text--right":"Card-module_text--right__uMFip","text--center":"Card-module_text--center__YoJ8y","text--justify":"Card-module_text--justify__U0YaE"};

const Card = ({
  align,
  children,
  className,
  size,
  type,
  layout
}) => {
  const classes = cx__default["default"](styles$b.card, className, styles$b[`card--${type}`], styles$b[`card--${layout}`], [styles$b[`card--${size}`]], [styles$b[`text--${align}`]]);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, children);
};

Card.defaultProps = {
  layout: 'column',
  type: 'default',
  align: 'left',
  size: 'default'
}; // @component ./CardContent.js

Card.Content = CardContent; // @component ./CardFooter.js

Card.Footer = CardFooter; // @component ./CardHeader.js

Card.Header = CardHeader; // @component ./CardMedia.js

Card.Media = CardMedia; // @component ./CardPlaceholder.js

Card.Placeholder = CardPlaceholder; // @component ./CardTitle.js

Card.Title = CardTitle; // @component ./CardFlag.js

Card.Flag = CardFlag;

const Twitter = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const FacebookBox = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Share = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

var styles$a = {"share":"SocialShare-module_share__aau-v","icons":"SocialShare-module_icons__CmFjd","wrapper":"SocialShare-module_wrapper__q932s","list":"SocialShare-module_list__JqBkC","isRight":"SocialShare-module_isRight__nbaNB","linkTwitter":"SocialShare-module_linkTwitter__zF4cC","linkFb":"SocialShare-module_linkFb__2gu4z"};

const SocialShare = ({
  url,
  title,
  twitterUsername,
  text,
  iconColor,
  iconSize,
  isRight
}) => {
  // Social links
  const twitterUsernameLink = twitterUsername ? `&via=${twitterUsername}` : '';
  const twitterShare = `https://twitter.com/share?url=${url}&text=${title}${twitterUsernameLink}`;
  const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  return /*#__PURE__*/React__namespace.createElement("div", null, /*#__PURE__*/React__namespace.createElement("div", {
    className: cx__default["default"](styles$a.wrapper, {
      [styles$a.isRight]: isRight
    })
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$a.icons
  }, /*#__PURE__*/React__namespace.createElement("ul", {
    className: cx__default["default"](styles$a.list)
  }, /*#__PURE__*/React__namespace.createElement("li", null, /*#__PURE__*/React__namespace.createElement("a", {
    href: twitterShare,
    "data-js": "social-share",
    target: "_blank",
    className: styles$a.linkTwitter,
    rel: "noreferrer"
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: "sr-only"
  }, "Share on Twitter"), /*#__PURE__*/React__namespace.createElement(Twitter, {
    color: iconColor,
    size: iconSize
  }))), /*#__PURE__*/React__namespace.createElement("li", null, /*#__PURE__*/React__namespace.createElement("a", {
    href: facebookShare,
    "data-js": "social-share",
    target: "_blank",
    className: styles$a.linkFb,
    rel: "noreferrer"
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: "sr-only"
  }, "Share on Facebook"), /*#__PURE__*/React__namespace.createElement(FacebookBox, {
    color: iconColor,
    size: iconSize
  }))))), /*#__PURE__*/React__namespace.createElement("span", {
    className: styles$a.share
  }, /*#__PURE__*/React__namespace.createElement(Share, {
    color: iconColor,
    size: iconSize
  }), /*#__PURE__*/React__namespace.createElement("span", {
    className: "sr-only"
  }, text))));
};

SocialShare.defaultProps = {
  text: 'Share',
  iconColor: '#999',
  iconSize: 22,
  isRight: false
};

var styles$9 = {"grid":"Grid-module_grid__TINES","gridcol2":"Grid-module_gridcol2__roxEB","gridcol3":"Grid-module_gridcol3__eDy5a","gridcol4":"Grid-module_gridcol4__3o9rU","gridcol5":"Grid-module_gridcol5__iyTSd","gridcol6":"Grid-module_gridcol6__--HbM","gridcol7":"Grid-module_gridcol7__QD7Hw","gridcol8":"Grid-module_gridcol8__0Gix7","gridcol9":"Grid-module_gridcol9__4Edrb","gridcol10":"Grid-module_gridcol10__M-DRw","gridcol11":"Grid-module_gridcol11__Dhc3j","gridcol12":"Grid-module_gridcol12__vrvG5","col1":"Grid-module_col1__0-xXu","col1inv":"Grid-module_col1inv__Sds46","col2":"Grid-module_col2__6UxjO","col2inv":"Grid-module_col2inv__l3z7-","col3":"Grid-module_col3__aaPgj","col3inv":"Grid-module_col3inv__Wh9Wh","col4":"Grid-module_col4__NQ9Cn","col4inv":"Grid-module_col4inv__S0yj7","col5":"Grid-module_col5__YDEtZ","col5inv":"Grid-module_col5inv__CzTVU","col6":"Grid-module_col6__2eTxr","col6inv":"Grid-module_col6inv__5B0fx","col7":"Grid-module_col7__Iw-Ul","col7inv":"Grid-module_col7inv__pKLfT","col8":"Grid-module_col8__WrCH-","col8inv":"Grid-module_col8inv__LUnWj","col9":"Grid-module_col9__lMBr0","col9inv":"Grid-module_col9inv__Kv4Ua","col10":"Grid-module_col10__XfnWC","col10inv":"Grid-module_col10inv__Z1Atz","col11":"Grid-module_col11__begti","col11inv":"Grid-module_col11inv__tj31h","col12":"Grid-module_col12__99hpX","col12inv":"Grid-module_col12inv__-5n-1","gridmobile__2":"Grid-module_gridmobile__2__MXsVl","gridmobile__3":"Grid-module_gridmobile__3__dOXP4","gridmobile__4":"Grid-module_gridmobile__4__3l9Fo","gridmobile__5":"Grid-module_gridmobile__5__SQDNN","gridmobile__6":"Grid-module_gridmobile__6__iNsi2","gridmobile__7":"Grid-module_gridmobile__7__Zy0en","gridmobile__8":"Grid-module_gridmobile__8__VT7bh","gridmobile__9":"Grid-module_gridmobile__9__Mlat4","gridmobile__10":"Grid-module_gridmobile__10__Fh7sx","gridmobile__11":"Grid-module_gridmobile__11__Azf0O","gridmobile__12":"Grid-module_gridmobile__12__LP1tH","gridtablet-narrow__2":"Grid-module_gridtablet-narrow__2__hhnk5","gridtablet-narrow__3":"Grid-module_gridtablet-narrow__3__wvz72","gridtablet-narrow__4":"Grid-module_gridtablet-narrow__4__UeZNe","gridtablet-narrow__5":"Grid-module_gridtablet-narrow__5__mM2dW","gridtablet-narrow__6":"Grid-module_gridtablet-narrow__6__53lrr","gridtablet-narrow__7":"Grid-module_gridtablet-narrow__7__e1HwA","gridtablet-narrow__8":"Grid-module_gridtablet-narrow__8__SVpQJ","gridtablet-narrow__9":"Grid-module_gridtablet-narrow__9__c-vVk","gridtablet-narrow__10":"Grid-module_gridtablet-narrow__10__NTs9S","gridtablet-narrow__11":"Grid-module_gridtablet-narrow__11__vhrMQ","gridtablet-narrow__12":"Grid-module_gridtablet-narrow__12__-Cngr","gridtablet__2":"Grid-module_gridtablet__2__qE-fC","gridtablet__3":"Grid-module_gridtablet__3__p2P-s","gridtablet__4":"Grid-module_gridtablet__4__oudP7","gridtablet__5":"Grid-module_gridtablet__5__N6t92","gridtablet__6":"Grid-module_gridtablet__6__VZuX0","gridtablet__7":"Grid-module_gridtablet__7__aQeOv","gridtablet__8":"Grid-module_gridtablet__8__gw1xX","gridtablet__9":"Grid-module_gridtablet__9__a80Lf","gridtablet__10":"Grid-module_gridtablet__10__-Rljh","gridtablet__11":"Grid-module_gridtablet__11__I7Lde","gridtablet__12":"Grid-module_gridtablet__12__q37DS","griddesktop__2":"Grid-module_griddesktop__2__1ExNL","griddesktop__3":"Grid-module_griddesktop__3__qOorC","griddesktop__4":"Grid-module_griddesktop__4__49YH6","griddesktop__5":"Grid-module_griddesktop__5__IRg9X","griddesktop__6":"Grid-module_griddesktop__6__glAn7","griddesktop__7":"Grid-module_griddesktop__7__3udqJ","griddesktop__8":"Grid-module_griddesktop__8__5kaBl","griddesktop__9":"Grid-module_griddesktop__9__vy5Yp","griddesktop__10":"Grid-module_griddesktop__10__uioFD","griddesktop__11":"Grid-module_griddesktop__11__PsRZA","griddesktop__12":"Grid-module_griddesktop__12__vrmdN"};

const Grid = ({
  children,
  className,
  breakpoints
}) => {
  const gridClasses = breakpoints.map(bp => {
    const option = Object.keys(bp)[0];
    const value = bp[option];
    const customClass = `grid${option}__${value}`;
    return styles$9[customClass];
  });
  const classes = cx__default["default"](styles$9.grid, className, gridClasses.join(' '));
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, children);
};

Grid.defaultProps = {
  breakpoints: [{
    mobile: 3
  }, {
    tablet: 4
  }, {
    desktop: 5
  }]
};

var styles$8 = {"layout":"Cover-module_layout__dKL1j","withCards":"Cover-module_withCards__jnJT0","strip":"Cover-module_strip__T7TMJ","stripHeader":"Cover-module_stripHeader__7duXV","coverTitle":"Cover-module_coverTitle__BuPGl","stripContent":"Cover-module_stripContent__loL3Z","flush":"Cover-module_flush__MQtWA","tag":"Cover-module_tag__yEhTe","buttonWrapper":"Cover-module_buttonWrapper__XjZHN"};

const DefaultCard = ({
  uuid,
  media,
  title,
  date,
  copy
}) => {
  return /*#__PURE__*/React__namespace.createElement(Card, {
    className: "card",
    key: uuid
  }, media && /*#__PURE__*/React__namespace.createElement(Card.Media, {
    src: media
  }), /*#__PURE__*/React__namespace.createElement(Card.Content, null, date && /*#__PURE__*/React__namespace.createElement(Copy, {
    className: cx__default["default"](styles$8.flush, styles$8.tag),
    tag: "small"
  }, date), title && /*#__PURE__*/React__namespace.createElement(Card.Title, {
    modifier: "flush",
    title: title,
    tag: "h3"
  }), copy && /*#__PURE__*/React__namespace.createElement(Copy, {
    tag: "p"
  }, copy)));
};

const Cover = ({
  title,
  intro,
  media,
  cards,
  breakpoints,
  titleType,
  coverLink,
  coverLinkText,
  cardRender: CardRender
}) => {
  const hasCards = cards && cards.length > 0 ? true : false;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: cx__default["default"](styles$8.layout, {
      [styles$8['withCards']]: hasCards
    })
  }, /*#__PURE__*/React__namespace.createElement(Image, {
    src: media,
    alt: title,
    title: title
  }), /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$8.strip
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$8.stripHeader
  }, /*#__PURE__*/React__namespace.createElement(Heading, {
    className: cx__default["default"](styles$8.flush, styles$8.coverTitle),
    tag: "h2",
    type: titleType
  }, title), /*#__PURE__*/React__namespace.createElement(Copy, {
    tag: "p"
  }, intro)), hasCards && /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$8.stripContent
  }, /*#__PURE__*/React__namespace.createElement(Grid, {
    breakpoints: breakpoints
  }, cards.map(item => /*#__PURE__*/React__namespace.createElement(CardRender, _extends$1({
    key: item.uuid
  }, item))))), coverLink && /*#__PURE__*/React__namespace.createElement("div", {
    className: styles$8.buttonWrapper
  }, /*#__PURE__*/React__namespace.createElement(Button, {
    tag: "link",
    href: coverLink,
    variants: ['primary'],
    text: coverLinkText
  }))));
};

Cover.defaultProps = {
  breakpoints: [{
    mobile: 2
  }, {
    tablet: 4
  }, {
    desktop: 4
  }],
  titleType: 'display',
  coverLinkText: 'More',
  cardRender: DefaultCard
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var r,B=r||(r={});B.Pop="POP";B.Push="PUSH";B.Replace="REPLACE";var C="production"!==process.env.NODE_ENV?function(b){return Object.freeze(b)}:function(b){return b};function D(b,h){if(!b){"undefined"!==typeof console&&console.warn(h);try{throw Error(h);}catch(e){}}}function E(b){b.preventDefault();b.returnValue="";}
function F(){var b=[];return {get length(){return b.length},push:function(h){b.push(h);return function(){b=b.filter(function(e){return e!==h});}},call:function(h){b.forEach(function(e){return e&&e(h)});}}}function H(){return Math.random().toString(36).substr(2,8)}function I(b){var h=b.pathname;h=void 0===h?"/":h;var e=b.search;e=void 0===e?"":e;b=b.hash;b=void 0===b?"":b;e&&"?"!==e&&(h+="?"===e.charAt(0)?e:"?"+e);b&&"#"!==b&&(h+="#"===b.charAt(0)?b:"#"+b);return h}
function J(b){var h={};if(b){var e=b.indexOf("#");0<=e&&(h.hash=b.substr(e),b=b.substr(0,e));e=b.indexOf("?");0<=e&&(h.search=b.substr(e),b=b.substr(0,e));b&&(h.pathname=b);}return h}
function createBrowserHistory(b){function h(){var c=p.location,a=m.state||{};return [a.idx,C({pathname:c.pathname,search:c.search,hash:c.hash,state:a.usr||null,key:a.key||"default"})]}function e(c){return "string"===typeof c?c:I(c)}function x(c,a){void 0===a&&(a=null);return C(_extends({pathname:q.pathname,hash:"",search:""},"string"===typeof c?J(c):c,{state:a,key:H()}))}function z(c){t=c;c=h();v=c[0];q=c[1];d.call({action:t,location:q});}function A(c,a){function f(){A(c,a);}var l=r.Push,k=x(c,
a);if(!g.length||(g.call({action:l,location:k,retry:f}),!1)){var n=[{usr:k.state,key:k.key,idx:v+1},e(k)];k=n[0];n=n[1];try{m.pushState(k,"",n);}catch(G){p.location.assign(n);}z(l);}}function y(c,a){function f(){y(c,a);}var l=r.Replace,k=x(c,a);g.length&&(g.call({action:l,location:k,retry:f}),1)||(k=[{usr:k.state,key:k.key,idx:v},e(k)],m.replaceState(k[0],"",k[1]),z(l));}function w(c){m.go(c);}void 0===b&&(b={});b=b.window;var p=void 0===b?document.defaultView:b,m=p.history,u=null;p.addEventListener("popstate",
function(){if(u)g.call(u),u=null;else {var c=r.Pop,a=h(),f=a[0];a=a[1];if(g.length)if(null!=f){var l=v-f;l&&(u={action:c,location:a,retry:function(){w(-1*l);}},w(l));}else "production"!==process.env.NODE_ENV?D(!1,"You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation."):
void 0;else z(c);}});var t=r.Pop;b=h();var v=b[0],q=b[1],d=F(),g=F();null==v&&(v=0,m.replaceState(_extends({},m.state,{idx:v}),""));return {get action(){return t},get location(){return q},createHref:e,push:A,replace:y,go:w,back:function(){w(-1);},forward:function(){w(1);},listen:function(c){return d.push(c)},block:function(c){var a=g.push(c);1===g.length&&p.addEventListener("beforeunload",E);return function(){a();g.length||p.removeEventListener("beforeunload",E);}}}}

var history = process.env.BROWSER && createBrowserHistory({
  basename: '',
  // The base URL of the app
  forceRefresh: false,
  // Set true to force full page refreshes
  keyLength: 6 // The length of location.key

});

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

var queryString = createCommonjsModule(function (module, exports) {





const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObj(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};
});
queryString.extract;
queryString.parse;
queryString.stringify;
queryString.parseUrl;
queryString.stringifyUrl;
queryString.pick;
queryString.exclude;

/**
 * Sorts an array of objects into alphabetical order.
 *
 * @param {object[]} array - Original array of Object's.
 * @param {string} key - Object key to use.
 * @returns {object[]} - New array of Object's.
 */
const orderAlphabetically = (array, key) => {
  array.sort((a, b) => {
    const textA = a[key].toUpperCase();
    const textB = b[key].toUpperCase();
    if (textA < textB) return -1;
    if (textA > textB) return 1;
    /**  Text is identical. */

    return 0;
  });
  return array;
};
/**
 * Helper to add any filters to aggregations.
 *
 * @param {object} filters
 * @param {string} currentFilterName
 * @returns {object}
 */

const applyAnyFilters = (filters, currentFilterName) => {
  const activeFilters = [];
  Object.keys(filters).filter(types => {
    if (types !== currentFilterName) {
      const {
        [types]: activeFilter
      } = filters;
      activeFilters.push(activeFilter);
      return true;
    }

    return false;
  });
  return activeFilters;
};
/**
 * Convert dot notation to nested bracket syntax.
 *
 * @param {*} obj
 * @param {*} prop
 */

function getNestedValue(obj, prop) {
  const props = prop.split('.');
  let value = obj;

  for (let i = 0; i < props.length; i++) {
    value = value[props[i]];
  }

  return value;
}
/**
 * Get unique objects form array.
 *
 * @param {Array} arr
 * @param {string} key
 *
 * @returns {Array}
 *
 * @memberof Search
 */


const getUnique = (arr, key) => {
  const unique = arr.map(e => getNestedValue(e, key)) // Store the keys of the unique objects
  .map((e, i, final) => final.indexOf(e) === i && i) // Eliminate the dead keys & store unique objects
  .filter(e => arr[e]).map(e => arr[e]);
  return unique;
};

/* eslint-disable */

const PAGINATION_SIZE = 10;
const SEARCH_KEYS = {
  search: 'q',
  pager: 'p'
};
/**
 * Order the aggregation items.
 * N.B. Range filters should not be ordered.
 *
 * @param {object} items
 * @param {string} name - Filter name.
 * @returns {object} - Ordered items.
 */

const orderAggregationItems = (items, name) => {
  let ordered = items;

  if (name === 'genres') {
    ordered = orderAlphabetically(items, 'key');
  }

  return ordered;
};
/**
 * Add aggregation filters.
 *
 * @param {Object} filters
 * @param {Object} appliedFilterTypes
 * @param {Object} filterSettings
 */

const addQueryAggregation = (filters, appliedFilterTypes, filterSettings) => {
  let aggs = {};
  aggs = Object.assign({}, ...filters.map(filter => {
    /** TODO: Allow passing filter size per filter type. */
    const filterSize = 20;
    const {
      [filter]: rangeFilter = false
    } = filterSettings === null || filterSettings === void 0 ? void 0 : filterSettings.RANGE_FILTERS_CONFIG;

    if (rangeFilter) {
      return {
        [`filter.${filter}`]: {
          filter: {
            bool: {
              must: applyAnyFilters(appliedFilterTypes, filter)
            }
          },
          aggs: {
            [filter]: {
              range: {
                field: filter,
                ranges: rangeFilter
              }
            }
          }
        }
      };
    }

    return {
      [`filter.${filter}`]: {
        filter: {
          match_all: {}
        },
        aggs: {
          all: {
            filter: {
              match_all: {}
            },
            aggs: {
              results: {
                terms: {
                  field: filter,
                  size: filterSize
                }
              }
            }
          },
          [filter]: {
            filter: {
              bool: {
                must: applyAnyFilters(appliedFilterTypes, filter)
              }
            },
            aggs: {
              results: {
                terms: {
                  field: filter,
                  size: filterSize
                }
              },
              results_count: {
                cardinality: {
                  field: filter
                }
              },
              total: {
                value_count: {
                  field: filter
                }
              }
            }
          }
        }
      }
    };
  }));
  return aggs;
};
/**
 * Sets up a filters query for elasticsearch.
 *
 * @param {object} req
 * @returns {object} - Request query.
 */


const addFilterQuery = req => {
  const {
    filters,
    filterSettings
  } = req;
  /** Apply filters. */

  let post_filter = {};
  const appliedFilterTypes = {};

  if (req.appliedFilters) {
    post_filter = {
      bool: {
        must: []
      }
    };
    const {
      appliedFilters
    } = req;
    Object.keys(appliedFilters).filter(appliedType => {
      const filterConfig = {
        bool: {
          should: [...appliedFilters[appliedType].map(item => {
            const {
              [appliedType]: rangeFilter = false
            } = filterSettings.RANGE_FILTERS_CONFIG;

            if (rangeFilter) {
              const config = rangeFilter.filter(range => range.key === item)[0];
              const {
                from = null,
                to = null
              } = config;
              const rangeData = {};
              if (from) rangeData.gte = from;
              if (to) rangeData.lt = to;
              return {
                range: {
                  [appliedType]: rangeData
                }
              };
            }

            return {
              match: {
                [appliedType]: item
              }
            };
          })]
        }
      };
      appliedFilterTypes[appliedType] = filterConfig;
      return post_filter.bool.must.push(filterConfig);
    });
  }

  const data = {
    query: post_filter,
    aggs: {}
  };
  data.aggs = addQueryAggregation(filters, appliedFilterTypes, filterSettings);
  return data;
};
/**
 * Merges and formats the returns data aggregation results.
 *
 * @param {Object} data
 * @param {string} name
 * @returns {Object} - Formatted items.
 */


const filterDataItems = (data, name) => {
  let dataItems;

  switch (name) {
    case 'duration_filter':
      {
        const {
          buckets: resultsBucket = [{
            doc_count: 0
          }]
        } = data[name];
        const allKey = 'All';
        const allKeyResult = resultsBucket.filter(({
          key
        }) => key === allKey);
        const allResult = resultsBucket.filter(({
          key
        }) => key !== allKey);
        dataItems = {
          allItemsRaw: allResult,
          itemsRaw: allResult,
          totalCount: allKeyResult[0].doc_count
        };
        break;
      }

    default:
      {
        const {
          all: {
            results: {
              buckets: allBuckets
            }
          } = {
            results: {
              buckets: []
            }
          }
        } = data;
        const {
          results: {
            buckets: resultsBucket
          } = {
            buckets: []
          },
          total: {
            value: total
          } = {
            value: 0
          }
        } = data[name];
        dataItems = {
          allItemsRaw: allBuckets,
          itemsRaw: resultsBucket,
          totalCount: total
        };
      }
  }

  return dataItems;
};
/**
 * Extracts the filter data from the elasticsearch response.
 *
 * @param {Object} response - The ES response.
 * @returns {Object}
 */

const extractFilterData = response => {
  /** Extract filter data. */
  let filters = {};

  if (response.aggregations) {
    /**
     * Picks out all filters from the response.
     * Key format: `filter.{filterName}`, as defined in `addFilterQuery()`.
     */
    Object.keys(response.aggregations).filter(aggType => {
      /** Picks out the filter name from the formatted key `filter.{filterName}` -> `{filterName}` */
      const filterName = aggType.split('.').pop();
      const filterData = filterDataItems(response.aggregations[aggType], filterName);
      const {
        allItemsRaw,
        itemsRaw,
        totalCount
      } = filterData;
      /** Order items. */

      const ordered = orderAggregationItems(allItemsRaw, filterName);
      /**
       * We merge all items and the filtered items together
       * as we want to always return all filter options,
       * and show them as `0`.
       */

      const items = ordered.map(({
        key
      }) => {
        /**
         * We always return all items, setting their count to `0`
         * if no items are in the filtered response for them.
         */
        let count = 0;
        itemsRaw.map(item => {
          if (item.key === key) {
            count = item.doc_count;
          }

          return true;
        });
        /** Altered format from ES for the FE. */

        return {
          name: key,
          count
        };
      });
      /** Add each filter type into the filters to return. */

      filters = { ...filters,
        [filterName]: {
          items,
          totalCount
        }
      };
      return true;
    });
  }

  return filters;
};
/**
 * Poor mans auto-complete search filters and additional aggregation.
 *
 * @param {object} req
 * @returns {object} - Request query.
 */

const getBySearch = req => {
  const {
    search,
    filters,
    filterSettings
  } = req;
  const data = {
    query: {},
    aggs: {}
  };
  /** Apply filters. */

  let post_filter = {};
  const appliedFilterTypes = {};

  if (req.appliedFilters) {
    post_filter = {
      bool: {
        must: []
      }
    };
    const {
      appliedFilters
    } = req;
    Object.keys(appliedFilters).filter(appliedType => {
      const filterConfig = {
        bool: {
          should: [...appliedFilters[appliedType].map(item => {
            const {
              [appliedType]: rangeFilter = false
            } = filterSettings.RANGE_FILTERS_CONFIG;

            if (rangeFilter) {
              const config = rangeFilter.filter(range => range.key === item)[0];
              const {
                from = null,
                to = null
              } = config;
              const rangeData = {};
              if (from) rangeData.gte = from;
              if (to) rangeData.lt = to;
              return {
                range: {
                  [appliedType]: rangeData
                }
              };
            }

            return {
              match: {
                [appliedType]: item
              }
            };
          })]
        }
      };
      appliedFilterTypes[appliedType] = filterConfig;
      return post_filter.bool.must.push(filterConfig);
    });
  }

  data.query.bool = {
    must: [{
      bool: {
        should: [{
          multi_match: {
            query: `.*${req[SEARCH_KEYS.search]}*.`,
            fields: search.fields,
            type: 'phrase'
          }
        }, {
          match: {
            enabled: {
              query: true
            }
          }
        }]
      }
    }]
  };

  if (search.prefixes) {
    search.prefixes.forEach(prefix => {
      const el = {
        match_phrase_prefix: {
          [prefix]: {
            query: `.*${req[SEARCH_KEYS.search]}*.`,
            max_expansions: 10
          }
        }
      };
      data.query.bool.must[0].bool.should.push(el);
    });
  }

  data.aggs = filters && filterSettings ? addQueryAggregation(filters, appliedFilterTypes, filterSettings) : {};
  return data;
};
/**
 * Setup Filter and Aggregations for fetching content by IDs.
 */


const getByIds = req => {
  const query = {
    bool: {
      must: [{
        ids: {
          values: req.ids
        }
      }]
    }
  };
  const data = {
    query,
    aggs: {}
  };
  return data;
};
/**
 * Map input parameters to a valid ES query object.
 *
 * @param {object} req
 * @param {object} res
 */


const elasticsearchQueryBuilder = req => {
  let query = null;
  let aggs = {};
  const doSearchQuery = req.search && req[SEARCH_KEYS.search];

  if (req.ids) {
    const data = getByIds(req);
    query = data.query ? { ...query,
      ...data.query
    } : query;
    aggs = { ...aggs,
      ...data.aggs
    };
  }

  if (doSearchQuery) {
    const data = getBySearch(req);
    query = data.query ? { ...query,
      ...data.query
    } : query;
    aggs = { ...aggs,
      ...data.aggs
    };
  }

  if (req.filters && !doSearchQuery) {
    const data = addFilterQuery(req);
    query = data.query ? { ...query,
      ...data.query
    } : query;
    aggs = { ...aggs,
      ...data.aggs
    };
  }
  /**
   * Get queried page number.
   * Subtract 1 from URL cosmetic page values for 0 indexed data from ES.
   */


  const page = req[SEARCH_KEYS.pager] > 0 ? req[SEARCH_KEYS.pager] - 1 : 0;
  /**
   * Get queried results count to display.
   * Explicit ternary used as 0 size evaluates to `false`, not the integer.
   */

  const reqSize = typeof req.size === 'number' ? parseInt(req.size, 10) : PAGINATION_SIZE;
  /**  Calculate `from`. */

  const from = page * reqSize;
  const queryObj = { ...(query && {
      query
    }),
    aggs,
    size: reqSize,
    from,
    sort: req.sort || {
      _score: 'desc'
    }
  };
  return queryObj;
};

/** Feature configuration. */
const SEARCH_TYPE_HIDDEN = 'hidden';
const SEARCH_TYPE_EXPOSED = 'exposed';
const SEARCH_THROTTLE_PERIOD = 500;
const SEARCH_RESULTS_SIZE = 12;
const SEARCH_CONFIG = {
  QUERY_KEY: 'q',
  PAGER_KEY: 'p',
  OPTIONS: {}
};
/** PAGINATION. */

const SEARCH_PAGINATION_LOADER = 'three-bounce'; // TODO cleanup constant usage.

const SEARCH_PAGER_TYPE = 'full';
const SEARCH_PAGER_TYPE_FULL = 'full';
const SEARCH_PAGER_TYPE_MINI = 'mini';
const SEARCH_PAGER_TYPE_INFINITE = 'infinite';
const SEARCH_PAGER_OFFSET$1 = 100;

var Constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SEARCH_TYPE_HIDDEN: SEARCH_TYPE_HIDDEN,
  SEARCH_TYPE_EXPOSED: SEARCH_TYPE_EXPOSED,
  SEARCH_THROTTLE_PERIOD: SEARCH_THROTTLE_PERIOD,
  SEARCH_RESULTS_SIZE: SEARCH_RESULTS_SIZE,
  SEARCH_CONFIG: SEARCH_CONFIG,
  SEARCH_PAGINATION_LOADER: SEARCH_PAGINATION_LOADER,
  SEARCH_PAGER_TYPE: SEARCH_PAGER_TYPE,
  SEARCH_PAGER_TYPE_FULL: SEARCH_PAGER_TYPE_FULL,
  SEARCH_PAGER_TYPE_MINI: SEARCH_PAGER_TYPE_MINI,
  SEARCH_PAGER_TYPE_INFINITE: SEARCH_PAGER_TYPE_INFINITE,
  SEARCH_PAGER_OFFSET: SEARCH_PAGER_OFFSET$1
});

/**
 * Call Search API.
 *
 * @param {string} endpoint - API url to fetch data from.
 * @param {string} key - Expected results key. Eg. `results`.
 * @param {object} query - Request data key:value pairs.
 * @param {object} config - Key configuration for pager, query, etc.
 * @param {object} strings - String UX message config.
 * @param {string} method - Fetch method.
 * @param {string} authHeader - Auth credentials if present.
 * @param {string} adapter - Name of search query adaptor to use.
 * @param {object} appliedFilters - Any applied filters.
 * @param {string} sort - Sort order for the query results.
 *
 * @returns {object} - SearchData.
 */

const searchFetchData = (endpoint, key, query, config, strings, method, authHeader, adapter, appliedFilters, sort) => {
  let message;
  const {
    options
  } = config;
  const PAGER = config.pager;
  const request = {
    [PAGER]: 0,
    options,
    ...query
  };
  let adaptorQuery;

  switch (adapter) {
    case 'ES':
      {
        const {
          esConfig
        } = config;
        const esRequest = { ...request,
          ...esConfig,
          appliedFilters,
          sort
        };
        adaptorQuery = elasticsearchQueryBuilder(esRequest);
      }
      break;

    default:
      adaptorQuery = request;
  }

  let apiHeaders = {
    'Content-Type': 'application/json'
  };

  if (authHeader) {
    apiHeaders = { ...apiHeaders,
      Authorization: authHeader
    };
  }

  const updatedQueryString = queryString.stringify(query, {
    encode: true,
    arrayFormat: 'index'
  });
  const fetchContents = method === 'POST' ? {
    method,
    headers: new Headers(apiHeaders),
    body: JSON.stringify(adaptorQuery)
  } : {
    method,
    headers: new Headers(apiHeaders)
  };
  const endpointUpdated = method === 'POST' ? endpoint : `${endpoint}?${updatedQueryString}`;
  return new Promise((resolve, reject) => {
    fetch(endpointUpdated, fetchContents).then(resp => {
      if (resp.ok) {
        return resp.json();
      }

      return reject(resp);
    }).then(json => {
      var _properties, _json$hits, _json$hits$total;

      // Traversing data object using provided key (provided as an array)
      // For use in returned object.
      const dataKeys = key.split('.');
      let properties = json;
      dataKeys.forEach(k => {
        properties = properties[k];
      });
      const {
        search
      } = config; // Return updated message if no query set.

      if (!search || search === '') {
        message = strings.searchMessage;
      } else if (((_properties = properties) === null || _properties === void 0 ? void 0 : _properties.length) === 0) {
        message = strings.searchNoResultsMessage;
      }

      const filters = extractFilterData(json);
      resolve({
        message,
        data: properties,
        total: json === null || json === void 0 ? void 0 : (_json$hits = json.hits) === null || _json$hits === void 0 ? void 0 : (_json$hits$total = _json$hits.total) === null || _json$hits$total === void 0 ? void 0 : _json$hits$total.value,
        size: request.size,
        page: request[SEARCH_CONFIG.PAGER_KEY],
        filters
      });
    }).catch(error => reject(error));
  });
};

/**
 * Helper searchGetKey for deciding current components active key.
 * Preference is given to key set via context.
 */

/**
 * @param {object} context - Context object from component.
 * @param {string} property - Component config prop.
 */
const searchGetKey = (context, property) => {
  const {
    config
  } = context;

  if (!config) {
    return null;
  }

  const key = config[property] ? config[property] : config;
  return key;
};

/**
 * Get query-string and apply logic.
 * This function only cares about what is currently set in the URL.
 *
 * @param {string} config - Passed query parameter config key eg "p".
 * @param {object} params - Optionally pass in the full query parameter set.
 *
 * @returns {string} - Querystring.
 */

const searchGetQuery = (config, params = null) => {
  // TODO - check if params is still required.
  if (!config) {
    return null;
  }
  /**
   * Server-side rendering application will not have `window` at certain points..
   */


  if (typeof window === 'undefined') {
    return null;
  }
  /**
   * Check is paramaters have been passed in with request..
   */


  let query;

  if (!params) {
    query = window.location.search;
  } else {
    query = params;
  }
  /**
   * Get query.
   */


  const parsed = queryString.parse(query, {
    arrayFormat: 'index'
  });
  /**
   * If query-string is empty just return empty string..
   */

  if (parsed && !Object.keys(parsed).length) {
    return '';
  }
  /**
   * Return empty string if config/URL is empty..
   */


  if (typeof config === 'string') {
    if (!parsed[config]) {
      return '';
    }

    return parsed[config];
  }

  return parsed;
};

/**
 * Library searchResetQuery for removing URL query.
 */

const searchResetQuery = () => {
  const {
    hash
  } = window.location;

  if (history) {
    history.push({
      search: null,
      hash
    });
  }
};

/**
 * Library searchUpdateHistory update history to latest query.
 *
 * @param {object} currentQuery - Current active query.
 * @param {object} parsed - Update API query object.
 */

const searchUpdateHistory = (currentQuery, parsed) => {
  /**
   * Setup new querystring.
   */
  const search = queryString.stringify(parsed, {
    encode: true,
    arrayFormat: 'index'
  });
  const {
    hash
  } = window.location;

  if (history && search !== currentQuery) {
    history.push({
      hash,
      search
    });
  }

  return parsed;
};

/**
 * Library searchUpdateQuery for Getting/Setting current query.
 *
 * @param {object} arg - Keyed object and new value to set.
 * @param {object} context - Config/context object.
 * @param {boolean} doPager - Page config setting.
 * @returns {object | null} - Querystring parameters.
 */

const searchUpdateQuery = (arg, context, doPager = false) => {
  // TODO - confirm if `doPager` is in use or can be removed.
  let parsed = queryString.parse(window.location.search, {
    arrayFormat: 'index'
  });
  /** Get context elements. */

  const {
    config,
    type
  } = context;
  const {
    pager
  } = config;
  /**
   * Store current querystring for usage later.
   */

  const currentQuery = queryString.stringify(parsed, {
    encode: true,
    arrayFormat: 'index'
  });
  /**
   * Check if new arg[value] exists in parsed.
   */

  Object.keys(parsed).forEach(key => {
    if (arg[key] === parsed[key]) {
      return null;
    }

    return true;
  });
  /**
   * Update parsed with current/new value.
   */

  parsed = Object.assign(parsed, arg);
  /**
   * Used to reset values on update.
   */

  if (parsed) {
    const parsedKeys = Object.keys(parsed);
    parsedKeys.map(d => {
      // Removed to fix deleting text field for dataOnLoad
      // DEBUG: if (parsed[d] === null || parsed[d] === '') {
      if (parsed[d] === null) {
        delete parsed[d];
      }

      return null;
    });
  }
  /**
   * Used to reset values on page load.
   */


  if (config) {
    const configKeys = Object.keys(config);
    configKeys.map(d => {
      // eslint-disable-next-line react/destructuring-assignment
      const k = context[d];

      if (arg[k] === null) {
        delete parsed[k];
      }

      return null;
    });
  }
  /**
   * Reset pager values on text (NOT .pager) query change.
   */


  if (config && Object.keys(arg)[0] !== pager) {
    delete parsed[pager];
  }
  /**
   * If search type is static, return the current query args from context.
   */


  if (type && type === SEARCH_TYPE_HIDDEN) {
    return parsed;
  }
  /**
   * If doPager is TRUE do not update history yet.
   */


  if (config && Object.keys(arg)[0] === pager && doPager) {
    return parsed;
  }
  /**
   * If search type is query, update `history` and then return the current query args.
   */


  if (type && type === SEARCH_TYPE_EXPOSED) {
    searchUpdateHistory(currentQuery, parsed);
  }

  return parsed;
};

var searchStrings = {
  GLOBAL: {
    CLEAR_ALL_LABEL: 'Clear all filters',
    LOAD_MORE_LABEL: 'more',
    SUBMIT_LABEL: 'submit',
    ARIASUBMIT_LABEL: 'search now',
    SEARCH_LABEL: 'Search',
    SEARCH_PLACEHOLDER: null,
    SEARCH_MESSAGE: 'Wanna search for something?',
    SEARCH_NO_RESULTS_MESSAGE: 'No results for {searchterm}.',
    SEARCH_ERROR_MESSAGE: 'oh no! There has been an error.'
  },
  PAGER: {},
  FILTERS: {
    SEARCH_FILTER_LABEL: 'Category'
  },
  RESET: {
    SEARCH_RESET_LABEL: 'Clear search'
  },
  PAGINATION: {
    NO_MORE_RESULTS: 'no more results',
    UI: {
      FIRST: 'First',
      LAST: 'Last',
      PREV: 'Prev',
      NEXT: 'Next',
      MORE: 'Load More'
    }
  }
};

const {
  QUERY_KEY: QUERY_KEY$1,
  PAGER_KEY: PAGER_KEY$1,
  OPTIONS: OPTIONS$1
} = SEARCH_CONFIG;
const {
  GLOBAL: {
    CLEAR_ALL_LABEL: CLEAR_ALL_LABEL$1,
    LOAD_MORE_LABEL: LOAD_MORE_LABEL$1,
    SUBMIT_LABEL: SUBMIT_LABEL$1,
    ARIASUBMIT_LABEL: ARIASUBMIT_LABEL$1,
    SEARCH_LABEL: SEARCH_LABEL$1,
    SEARCH_PLACEHOLDER: SEARCH_PLACEHOLDER$1,
    SEARCH_MESSAGE: SEARCH_MESSAGE$1,
    SEARCH_NO_RESULTS_MESSAGE: SEARCH_NO_RESULTS_MESSAGE$1,
    SEARCH_ERROR_MESSAGE: SEARCH_ERROR_MESSAGE$1
  }
} = searchStrings;
const strings = {
  clearAllLabel: CLEAR_ALL_LABEL$1,
  loadMoreLabel: LOAD_MORE_LABEL$1,
  submitLabel: SUBMIT_LABEL$1,
  ariaSubmitLabel: ARIASUBMIT_LABEL$1,
  searchLabel: SEARCH_LABEL$1,
  searchPlaceholder: SEARCH_PLACEHOLDER$1,
  message: SEARCH_MESSAGE$1,
  searchNoResultsMessage: SEARCH_NO_RESULTS_MESSAGE$1,
  searchErrorMessage: SEARCH_ERROR_MESSAGE$1
};
const defaultContext = {
  // FROM STATE.
  data: null,
  total: 0,
  isPaging: false,
  currentPage: 0,
  message: strings.message,
  loading: false,
  query: {},
  pagerInView: false,
  appliedFilters: {},
  filters: {},
  sort: null,
  // FROM PROPS.
  size: SEARCH_RESULTS_SIZE,
  config: {
    search: QUERY_KEY$1,
    pager: PAGER_KEY$1,
    filters: null,
    options: OPTIONS$1
  },
  type: SEARCH_TYPE_EXPOSED,
  pagerType: SEARCH_PAGER_TYPE,
  // COMPONENT FUNCS.
  resetPagerInView: () => {},
  fetch: () => {},
  clearFilters: () => {},
  clearFilterGroup: () => {},
  applyFilter: () => {}
};
/** Feature context. */

const SearchContext = /*#__PURE__*/React__namespace.createContext(defaultContext);
SearchContext.Consumer;

/**
 * Debounce function action.
 *
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 *
 * @returns {Function}
 */
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;

    var later = function () {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

var pluralize = createCommonjsModule(function (module, exports) {
/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (typeof commonjsRequire === 'function' && 'object' === 'object' && 'object' === 'object') {
    // Node.
    module.exports = pluralize();
  } else {
    // Browser global.
    root.pluralize = pluralize();
  }
})(commonjsGlobal, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) return token;

    // Lower cased words. E.g. "hello".
    if (word === word.toLowerCase()) return token.toLowerCase();

    // Upper cased words. E.g. "WHISKY".
    if (word === word.toUpperCase()) return token.toUpperCase();

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */
  function replace (word, rule) {
    return word.replace(rule[0], function (match, index) {
      var result = interpolate(rule[1], arguments);

      if (match === '') {
        return restoreCase(word[index - 1], result);
      }

      return restoreCase(match, result);
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */
  function sanitizeWord (token, word, rules) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = rules.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = rules[len];

      if (rule[0].test(word)) return replace(word, rule);
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Check if a word is part of the map.
   */
  function checkWord (replaceMap, keepMap, rules, bool) {
    return function (word) {
      var token = word.toLowerCase();

      if (keepMap.hasOwnProperty(token)) return true;
      if (replaceMap.hasOwnProperty(token)) return false;

      return sanitizeWord(token, token, rules) === token;
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Check if a word is plural.
   *
   * @type {Function}
   */
  pluralize.isPlural = checkWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Check if a word is singular.
   *
   * @type {Function}
   */
  pluralize.isSingular = checkWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['passerby', 'passersby']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
    [/(test)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'adulthood',
    'advice',
    'agenda',
    'aid',
    'aircraft',
    'alcohol',
    'ammo',
    'analytics',
    'anime',
    'athletics',
    'audio',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'cod',
    'commerce',
    'cooperation',
    'corps',
    'debris',
    'diabetes',
    'digestion',
    'elk',
    'energy',
    'equipment',
    'excretion',
    'expertise',
    'firmware',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'hardware',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'mud',
    'manga',
    'news',
    'only',
    'personnel',
    'pike',
    'plankton',
    'pliers',
    'police',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'software',
    'species',
    'staff',
    'swine',
    'tennis',
    'traffic',
    'transportation',
    'trout',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    /pok[eé]mon$/i,
    // Regexes.
    /[^aeiou]ese$/i, // "chinese", "japanese"
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /measles$/i,
    /o[iu]s$/i, // "carnivorous"
    /pox$/i, // "chickpox", "smallpox"
    /sheep$/i
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});
});

const SearchCount = ({
  className,
  message,
  count,
  pluralString
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  total
}) => {
  const counts = count || total;

  if (!counts) {
    return null;
  }

  const pluralizedString = pluralize(pluralString, total); // NB: Flow not detecting defaultProps: https://github.com/facebook/flow/issues/6644

  const messageString = message && message.replace('{pluralString}', pluralizedString);
  const renderMessage = messageString && messageString.replace('{count}', counts);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className
  }, renderMessage);
});

SearchCount.defaultProps = {
  message: '{count} {pluralString}',
  count: 0,
  pluralString: 'result'
};
SearchCount.displayName = 'Search.Count';

const SearchData = ({
  className,
  dataList: DataList,
  dataItems: DataItems
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  data,
  loading
}) => {
  if (!data || loading) {
    return null;
  }

  return /*#__PURE__*/React__namespace.createElement(DataList, {
    className: className
  }, /*#__PURE__*/React__namespace.createElement(DataItems, {
    data: data
  }));
});

SearchData.displayName = 'Search.Data';

const SearchInput = ({
  className,
  strings,
  labelHide,
  required
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  config,
  type,
  query,
  fetch
}) => {
  /** Get component query key. */
  const data = searchGetKey({
    config,
    type,
    query,
    fetch
  }, 'search');
  /**
   * Handle form element change event.
   *
   * @param {object} event
   */

  const handleChange = event => {
    // Set query based on current value.
    const searchTerm = event.target.value; // Return query value and use for static context setter.

    const fetchArgs = searchUpdateQuery({
      [data]: searchTerm
    }, {
      config,
      type,
      query,
      fetch
    }); // Check valid callback is setup for context and pass new args up.

    if (fetch && type && type === 'hidden') {
      fetch(fetchArgs);
    }
  };
  /** Define component label classes. */


  const labelClass = cx__default["default"]({
    'sr-only': labelHide
  });
  /** Get initial value on render. */

  const value = query && query[data] ? query[data] : searchGetQuery(data) || '';
  return /*#__PURE__*/React__namespace.createElement(FormField, {
    id: "search-text",
    type: "search",
    value: value,
    required: required,
    label: (strings === null || strings === void 0 ? void 0 : strings.searchLabel) || 'search input',
    placeholder: strings === null || strings === void 0 ? void 0 : strings.searchPlaceholder,
    labelClasses: labelClass,
    onChange: handleChange,
    className: className
  });
});

SearchInput.defaultProps = {
  strings: {
    searchLabel: 'Search',
    searchPlaceholder: null
  },
  labelHide: false,
  required: false
};
SearchInput.displayName = 'Search.Input';

var styles$7 = {"loader":"Loader-module_loader__C1wkN","inverted":"Loader-module_inverted__czAub","chasing-circles":"Loader-module_chasing-circles__UCSsl","chasing-circles__circle":"Loader-module_chasing-circles__circle__xFLXB","circle-bounce-delay":"Loader-module_circle-bounce-delay__6QXBY","chasing-circles__circle2":"Loader-module_chasing-circles__circle2__YIzhn","chasing-circles__circle3":"Loader-module_chasing-circles__circle3__P6k-L","chasing-circles__circle4":"Loader-module_chasing-circles__circle4__5kDr8","chasing-circles__circle5":"Loader-module_chasing-circles__circle5__kHz4a","chasing-circles__circle6":"Loader-module_chasing-circles__circle6__Zf8dY","chasing-circles__circle7":"Loader-module_chasing-circles__circle7__D6mGw","chasing-circles__circle8":"Loader-module_chasing-circles__circle8__V0Eqs","chasing-circles__circle9":"Loader-module_chasing-circles__circle9__biyzw","chasing-circles__circle10":"Loader-module_chasing-circles__circle10__ATU9E","chasing-circles__circle11":"Loader-module_chasing-circles__circle11__7yy4q","chasing-circles__circle12":"Loader-module_chasing-circles__circle12__AAHKy","chasing-dots":"Loader-module_chasing-dots__Imp05","chasingDotsRotate":"Loader-module_chasingDotsRotate__RYaSm","chasing-dots__dot":"Loader-module_chasing-dots__dot__xuBn8","chasingDotsBounce":"Loader-module_chasingDotsBounce__T45Wy","chasing-dots__dot2":"Loader-module_chasing-dots__dot2__tDXHp","cube-grid":"Loader-module_cube-grid__Rzu0g","cube-grid__cube":"Loader-module_cube-grid__cube__oIsed","cube-grid-scale-delay":"Loader-module_cube-grid-scale-delay__ochRd","cube-grid__cube1":"Loader-module_cube-grid__cube1__iRM64","cube-grid__cube2":"Loader-module_cube-grid__cube2__zjVbA","cube-grid__cube3":"Loader-module_cube-grid__cube3__EcDNq","cube-grid__cube4":"Loader-module_cube-grid__cube4__ofSnp","cube-grid__cube5":"Loader-module_cube-grid__cube5__-fg-H","cube-grid__cube6":"Loader-module_cube-grid__cube6__TYoee","cube-grid__cube7":"Loader-module_cube-grid__cube7__TSJ1X","cube-grid__cube8":"Loader-module_cube-grid__cube8__8VgR1","cube-grid__cube9":"Loader-module_cube-grid__cube9__5jKLu","double-bounce":"Loader-module_double-bounce__FKU1n","double-bounce__item":"Loader-module_double-bounce__item__uJWc-","doubleBounce":"Loader-module_doubleBounce__rCsmw","double-bounce__item2":"Loader-module_double-bounce__item2__wQEhN","fading-circle":"Loader-module_fading-circle__8FngQ","fading-circle__circle":"Loader-module_fading-circle__circle__eogk1","circleFadeDelay":"Loader-module_circleFadeDelay__EQONu","fading-circle__circle2":"Loader-module_fading-circle__circle2__PJjV6","fading-circle__circle3":"Loader-module_fading-circle__circle3__HnSd7","fading-circle__circle4":"Loader-module_fading-circle__circle4__-aLqb","fading-circle__circle5":"Loader-module_fading-circle__circle5__WPbi2","fading-circle__circle6":"Loader-module_fading-circle__circle6__uDKW9","fading-circle__circle7":"Loader-module_fading-circle__circle7__YC05k","fading-circle__circle8":"Loader-module_fading-circle__circle8__fAVJ1","fading-circle__circle9":"Loader-module_fading-circle__circle9__2Ckh0","fading-circle__circle10":"Loader-module_fading-circle__circle10__aX5o7","fading-circle__circle11":"Loader-module_fading-circle__circle11__zW2K2","fading-circle__circle12":"Loader-module_fading-circle__circle12__xCFtl","folding-cube":"Loader-module_folding-cube__Hm-8c","folding-cube__cube":"Loader-module_folding-cube__cube__U-nwA","foldCubeAngle":"Loader-module_foldCubeAngle__5gLxz","folding-cube__cube2":"Loader-module_folding-cube__cube2__apmci","folding-cube__cube3":"Loader-module_folding-cube__cube3__WcVUp","folding-cube__cube4":"Loader-module_folding-cube__cube4__N56ti","spinner--pulse":"Loader-module_spinner--pulse__z5NVJ","pulseScaleOut":"Loader-module_pulseScaleOut__iVPQa","rotating-plane":"Loader-module_rotating-plane__fHive","rotatePlane":"Loader-module_rotatePlane__DgWcI","three-bounce":"Loader-module_three-bounce__CPVzW","three-bounce__item":"Loader-module_three-bounce__item__n5HpC","three-bounce__item1":"Loader-module_three-bounce__item1__0kjtg","three-bounce__item2":"Loader-module_three-bounce__item2__4MS6e","wandering-cubes":"Loader-module_wandering-cubes__n5wWb","wandering-cubes__cube":"Loader-module_wandering-cubes__cube__qsZ4B","wandering-cube":"Loader-module_wandering-cube__JJELo","wandering-cubes__cube2":"Loader-module_wandering-cubes__cube2__x3x05","waves":"Loader-module_waves__ijLNf","waves__wave":"Loader-module_waves__wave__JrMCt","waveStretchDelay":"Loader-module_waveStretchDelay__DwOBI","waves__wave1":"Loader-module_waves__wave1__hEvK3","waves__wave2":"Loader-module_waves__wave2__proeg","waves__wave3":"Loader-module_waves__wave3__t8ODG","waves__wave4":"Loader-module_waves__wave4__fFIQO","waves__wave5":"Loader-module_waves__wave5__fLCSb","circle-dash":"Loader-module_circle-dash__OlUYq","circular":"Loader-module_circular__IhUI4","cd-rotate":"Loader-module_cd-rotate__C4Yt9","path":"Loader-module_path__gWtVB","cd-dash":"Loader-module_cd-dash__Ccx4j","cd-color":"Loader-module_cd-color__vEnSb","cd-color-inverted":"Loader-module_cd-color-inverted__Lyu-D"};

const Loader = ({
  className,
  inverted,
  type
}) => {
  switch (type) {
    case 'circle':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['chasing-circles'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7['chasing-circles__circle'], styles$7[`chasing-circles__circle${i}`])
      })));

    case 'cube-grid':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['cube-grid'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7[`cube-grid__cube${i}`], styles$7['cube-grid__cube'])
      })));

    case 'double-bounce':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['double-bounce'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7[`double-bounce__item${i}`], styles$7['double-bounce__item'])
      })));

    case 'fading-circle':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['fading-circle'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7[`fading-circle__circle${i}`], styles$7['fading-circle__circle'])
      })));

    case 'folding-cube':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['folding-cube'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 4, 3].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7[`folding-cube__cube${i}`], styles$7['folding-cube__cube'])
      })));

    case 'pulse':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7.spinner, styles$7['spinner--pulse'], className, {
          [styles$7.inverted]: inverted
        })
      });

    case 'rotating-plane':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['rotating-plane'], className, {
          [styles$7.inverted]: inverted
        })
      });

    case 'three-bounce':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['three-bounce'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 3].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7[`three-bounce__item${i}`], styles$7['three-bounce__item'])
      })));

    case 'wandering-cubes':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['wandering-cubes'], className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 3].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7[`wandering-cubes__cube${i}`], styles$7['wandering-cubes__cube'])
      })));

    case 'wave':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7.waves, className, {
          [styles$7.inverted]: inverted
        })
      }, [1, 2, 3, 4, 5].map(i => /*#__PURE__*/React__namespace.createElement("div", {
        key: i,
        className: cx__default["default"](styles$7.waves__wave, styles$7[`waves__wave${i}`])
      })));

    case 'circle-dash':
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7['circle-dash'], className, {
          [styles$7.inverted]: inverted
        })
      }, /*#__PURE__*/React__namespace.createElement("svg", {
        className: styles$7.circular,
        viewBox: "25 25 50 50"
      }, /*#__PURE__*/React__namespace.createElement("circle", {
        className: styles$7.path,
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      })));

    default:
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: cx__default["default"](styles$7.loader, className, {
          [styles$7.inverted]: inverted
        })
      });
  }
};

Loader.defaultProps = {
  inverted: false,
  type: 'circle-dash',
  className: ''
};

const SearchLoader = ({
  className,
  type
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  loading
}) => {
  if (!loading) {
    return null;
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className
  }, /*#__PURE__*/React__namespace.createElement(Loader, {
    type: type
  }));
});

SearchLoader.defaultProps = {
  type: 'circle-dash'
};
SearchLoader.displayName = 'Search.Loader';

const SearchMessage = ({
  className
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  message,
  loading
}) => {
  if (loading) {
    return null;
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className
  }, message || '');
});

SearchMessage.displayName = 'Search.Message';

const MiniPager = ({
  strings,
  currentPage,
  defaultPage,
  totalPages,
  paginate
}) => {
  const disablePrevFirst = () => {
    if (Number(currentPage) === defaultPage) {
      return true;
    }

    return false;
  };

  const disableNextLast = () => {
    if (Number(currentPage) === totalPages) {
      return true;
    }

    return false;
  };
  /**
   * Trigger callback pagination for parent component.
   *
   * @param {*} event - Click event handler.
   */


  const handleCallBack = event => paginate(event.target.id);

  return /*#__PURE__*/React__namespace.createElement(ButtonGroup, {
    className: "grid--col-2"
  }, /*#__PURE__*/React__namespace.createElement(Button, {
    id: "pager-prev",
    tag: "button",
    variant: "primary",
    disabled: disablePrevFirst(),
    onClick: handleCallBack,
    text: strings === null || strings === void 0 ? void 0 : strings.prev
  }), /*#__PURE__*/React__namespace.createElement(Button, {
    id: "pager-next",
    tag: "button",
    variant: "primary",
    disabled: disableNextLast(),
    onClick: handleCallBack,
    text: strings === null || strings === void 0 ? void 0 : strings.next
  }));
};

MiniPager.defaultProps = {
  strings: null,
  currentPage: null,
  defaultPage: null,
  totalPages: null
};

const {
  SEARCH_PAGER_OFFSET
} = Constants;

const InfinitePager = ({
  loaderType,
  buttonText,
  onScroll,
  onPagerInViewComplete,
  paginate
}) => {
  const pagerButton = React__namespace.useRef();
  const context = React__namespace.useContext(SearchContext);
  const {
    isPaging
  } = context;
  let scrollListener; // eslint-disable-next-line consistent-return

  React__namespace.useEffect(() => {
    /** Check if the pager is in view on mount. */

    /** Only trigger pagerInView if paginateOnScroll type is `true`. */

    /**
     * Paginate trigger via scroll listener.
     *
     * @memberof InfinitePager
     */
    const loadMorePagerInView = () => {
      if (pagerButton.current && !isPaging) {
        const {
          top
        } = pagerButton.current.getBoundingClientRect();

        if (top < window.innerHeight + SEARCH_PAGER_OFFSET) {
          paginate('pager-loadmore');
        }

        return true;
      }

      return false;
    };
    /**
     * Scroll-wheel EventListener callback.
     *
     * @param {object} event
     * @memberof InfinitePager
     */


    const wheelListener = event => {
      if (event.deltaY === 1) {
        event.preventDefault();
      }
    };

    if (onScroll) {
      /** Check if the pager is in view on mount. */
      loadMorePagerInView();
      onPagerInViewComplete();
      scrollListener = debounce(loadMorePagerInView, 10);
      window.addEventListener('scroll', scrollListener, {
        passive: true
      });
      /**
       * Hacked solutions to Google Chrome's browsers' handling of
       * event listeners. Whilst the scroll event is not yet complete.
       * Https://stackoverflow.com/a/47684257.
       *
       * Related : https://stackoverflow.com/questions/35024301/xhr-settimeout-promise-not-finishing-until-scrolling-stops-in-chrome
       * WheelEvent : https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent used and mousewheel is deprecated.
       */

      window.addEventListener('wheel', wheelListener);
      return () => {
        /**
         * Remove all event listeners.
         */
        window.removeEventListener('scroll', scrollListener);
        window.removeEventListener('wheel', wheelListener);
      };
    }
  }, []);
  return /*#__PURE__*/React__namespace.createElement("div", {
    ref: pagerButton
  }, /*#__PURE__*/React__namespace.createElement(Loader, {
    type: loaderType,
    className: !isPaging ? 'element-opaque' : 'loader'
  }), /*#__PURE__*/React__namespace.createElement(Button, {
    id: "pager-loadmore",
    type: "submit",
    variants: ['primary', 'small'],
    onClick: () => paginate('pager-loadmore'),
    className: onScroll ? 'sr-only' : null,
    text: buttonText
  }));
};

InfinitePager.defaultProps = {
  buttonText: searchStrings.GLOBAL.LOAD_MORE_LABEL,
  onScroll: false,
  loaderType: 'circle'
};

const FullPager = ({
  strings,
  currentPage,
  defaultPage,
  totalPages,
  data,
  paginate
}) => {
  /**
   * Check disabled status for Previous and First buttons.
   *
   * @returns {boolean}
   */
  const disablePrevFirst = () => {
    if (Number(currentPage) === defaultPage) {
      return true;
    }

    return false;
  };
  /**
   * Check disabled status for Next and Last buttons.
   *
   * @returns {boolean}
   */


  const disableNextLast = () => {
    if (Number(currentPage) === totalPages) {
      return true;
    }

    return false;
  };
  /**
   * Trigger callback pagination for parent component.
   *
   * @param {object} event - Click event handler.
   */


  const handleCallBack = event => {
    /* Deprecated.
    if (event.target.value) {
      const { value } = event.target;
      paginate('pager--page', value);
      return;
    }
    */

    /**
     * Handler for all cases except set page value.
     */
    const {
      id
    } = event.target;
    paginate(id);
  };

  const paginationRender = data.map(page => {
    if (page === Number(currentPage) || page === '...') {
      /**
       * Return plain text if current page or ellipsis, as rendering a link is redundant.
       */
      return page;
    }

    const buttonText = ` ${page} `;
    return /*#__PURE__*/React__namespace.createElement(Button, {
      className: "pager--page",
      key: `page-${page}`,
      variants: ['link'],
      onClick: handleCallBack,
      value: page,
      text: buttonText
    });
  });
  const {
    first,
    prev,
    next,
    last
  } = strings;
  const buttonsData = [{
    id: 'pager-first',
    label: first,
    disabled: disablePrevFirst
  }, {
    id: 'pager-prev',
    label: prev,
    disabled: disablePrevFirst
  }, {
    render: paginationRender
  }, {
    id: 'pager-next',
    label: next,
    disabled: disableNextLast
  }, {
    id: 'pager-last',
    label: last,
    disabled: disableNextLast
  }]; // Pass a function to map

  const buttons = buttonsData.map(config => {
    if (config.render) {
      return config.render;
    }

    return /*#__PURE__*/React__namespace.createElement(Button, {
      key: config.id,
      id: config.id,
      tag: "button",
      variant: "primary",
      disabled: config.disabled(),
      onClick: handleCallBack,
      text: config.label
    });
  });
  return /*#__PURE__*/React__namespace.createElement(ButtonGroup, null, buttons);
};

FullPager.defaultProps = {
  currentPage: null,
  defaultPage: null,
  totalPages: null
};

const {
  NO_MORE_RESULTS,
  UI: {
    FIRST,
    LAST,
    PREV,
    NEXT,
    MORE
  }
} = searchStrings.PAGINATION;

const SearchPagination = ({
  className,
  defaultPage,
  noMoreResults,
  paginateOnScroll,
  loaderType,
  pagerBase
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  size,
  total,
  data,
  config,
  loading,
  currentPage,
  fetch,
  resetPagerInView,
  pagerType
}) => {
  /**
   * Calculate total number of pages.
   *
   * @returns {number}
   */
  const getNumberOfPages = () => Math.ceil(total / size);
  /**
   * Set `No more results` state.
   *
   * @returns {boolean}
   */


  const noMoreResultsHandler = () => {
    if (Number(currentPage) === getNumberOfPages()) {
      return true;
    }

    return false;
  };
  /**
   * Calculate FULL pagination output.
   */


  const pagerOutputHandler = () => {
    const delta = 2;
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const numberOfPages = getNumberOfPages();
    let range = [];
    let rangeWithDots = [];
    let l;

    for (let i = 1; i <= numberOfPages; i++) {
      if (i === 1 || i === numberOfPages || i >= left && i < right) {
        range = [...range, i];
      }
    }

    range.forEach(i => {
      if (l) {
        if (i - l !== 1) {
          rangeWithDots = [...rangeWithDots, '...'];
        }
      }

      rangeWithDots = [...rangeWithDots, i];
      l = i;
    });
    return rangeWithDots;
  };
  /**
   * Trigger hidden state.
   *
   * @returns {boolean}
   */


  const hide = () => {
    if (total <= size) {
      return true;
    }

    return false;
  };
  /**
   * Trigger Content Callback function.
   *
   * @param {string} key - Pagination config key.
   * @param {string} value - Current pagination value.
   */


  const changeHandler = (key, value) => {
    if (fetch) {
      /** Set TRUE to confirm action is from pager. */
      fetch({
        [key]: value
      }, {
        loading: true,
        value
      });
    }
  };
  /**
   * Trigger search pagination event.
   *
   * @param {string} arg - Switch statement parameter for which pagination set to action.
   * @param {number|null} val - Optional value to set query attribute too.
   */


  const paginate = (arg, val = null) => {
    const {
      pager
    } = config;
    const cp = Number(currentPage);

    switch (arg) {
      case 'pager-first':
        changeHandler(pager, 1);
        break;

      case 'pager-next':
      case 'pager-loadmore':
        {
          /** Default to page 2, when no currentPage value present. */
          const pBase = pagerBase || 0;
          const value = cp ? cp + 1 : pBase + 1;
          changeHandler(pager, value);
        }
        break;

      case 'pager-prev':
        {
          const value = cp - 1;
          changeHandler(pager, value);
        }
        break;

      case 'pager-last':
        {
          const value = getNumberOfPages();
          changeHandler(pager, value);
        }
        break;

      case 'pager--page':
        {
          const value = val;
          changeHandler(pager, value);
        }
        break;
    }
  };
  /**
   * Callback for the infinite pager to reset the check boolean.
   */


  const changePagerInViewComplete = () => {
    if (resetPagerInView && paginateOnScroll) {
      resetPagerInView();
    }
  };
  /**
   * Setup string object based on static default and provided default props.
   * This is required to avoid missing nested props values.
   */


  const allLabels = {
    first: FIRST,
    last: LAST,
    prev: PREV,
    next: NEXT,
    more: MORE,
    ...searchStrings
  };
  const isHidden = hide();

  if (isHidden || loading || !data || data.length === 0) {
    return null;
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className
  }, pagerType === SEARCH_PAGER_TYPE_FULL && /*#__PURE__*/React__namespace.createElement(FullPager, {
    strings: allLabels,
    defaultPage: defaultPage,
    currentPage: currentPage,
    totalPages: getNumberOfPages(),
    data: pagerOutputHandler(),
    paginate: paginate
  }), pagerType === SEARCH_PAGER_TYPE_MINI && /*#__PURE__*/React__namespace.createElement(MiniPager, {
    strings: allLabels,
    defaultPage: defaultPage,
    currentPage: currentPage,
    totalPages: getNumberOfPages(),
    paginate: paginate
  }), pagerType === SEARCH_PAGER_TYPE_INFINITE && (!noMoreResultsHandler() ? /*#__PURE__*/React__namespace.createElement(InfinitePager, {
    strings: allLabels,
    paginate: paginate,
    onScroll: paginateOnScroll,
    onPagerInViewComplete: changePagerInViewComplete,
    loaderType: loaderType
  }) : /*#__PURE__*/React__namespace.createElement(Copy, {
    className: "pager__no-results"
  }, noMoreResults)));
});

SearchPagination.defaultProps = {
  defaultPage: 1,
  noMoreResults: NO_MORE_RESULTS,
  paginateOnScroll: false,
  loaderType: null,
  pagerBase: 0
};
SearchPagination.displayName = 'Search.Pagination';

const {
  SEARCH_RESET_LABEL
} = searchStrings.RESET;

const SearchReset = ({
  className,
  label
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  type,
  fetch
}) => {
  const handleClick = () => {
    if (!type) {
      return false;
    }

    if (type === 'exposed') {
      searchResetQuery();
      return true;
    }
    /** Check valid callback is setup for context and pass new args up. */


    if (fetch) {
      fetch({}, false, true);
    }

    return true;
  };

  return /*#__PURE__*/React__namespace.createElement(Button, {
    className: className,
    onClick: handleClick,
    text: label
  });
});

SearchReset.defaultProps = {
  label: SEARCH_RESET_LABEL
};
SearchReset.displayName = 'Search.Reset';

const SearchResultsItems = ({
  data
}) => {
  if (!data || data.length === 0) {
    return null;
  }

  return data.map(result => /*#__PURE__*/React__namespace.createElement("div", {
    key: result.uuid
  }, result.title));
};

SearchResultsItems.displayName = 'Search.ResultsItems';

const SearchResultsList = ({
  children
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: "ncl-grid ncl-grid--col-4"
}, children);

SearchResultsList.displayName = 'Search.ResultsList';

const SearchFilterMenu = ({
  className,
  filterClear: FilterClear,
  filterMenu: FilterMenu,
  filterMenuItem: FilterMenuItem,
  name,
  heading
}) => /*#__PURE__*/React__namespace.createElement(SearchContext.Consumer, null, ({
  filters,
  applyFilter,
  appliedFilters,
  clearFilterGroup
}) => {
  /* @todo - test coverage 
  console.info('filters', filters);
  console.info('name', name);
  console.info('filters[name]', filters[name]);
  */
  if (!filters || !filters[name]) {
    return null;
  }
  /** This filter menu's active filters. */


  const activeFilters = appliedFilters[name];
  const isFiltered = appliedFilters && appliedFilters[name];

  const clear = () => clearFilterGroup(name);

  const apply = event => applyFilter(event, name);

  return /*#__PURE__*/React__namespace.createElement(FilterMenu, null, heading, isFiltered && /*#__PURE__*/React__namespace.createElement(FilterClear, {
    onClick: clear
  }, "Clear all"), !isFiltered && /*#__PURE__*/React__namespace.createElement(FilterMenuItem, {
    active: true,
    name: "All",
    count: filters[name].totalCount
  }), filters[name].items.map(item => {
    const active = activeFilters && activeFilters.includes(item.name);
    const disabled = item.count === 0 && !activeFilters || item.count === 0 && activeFilters && !activeFilters.includes(item.name);
    return /*#__PURE__*/React__namespace.createElement("div", {
      className: className,
      key: item.name
    }, /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(FormField, {
      type: "checkbox",
      id: `${name}--${item.name}`,
      name: item.name,
      value: item.name,
      input: {
        name: item.name,
        value: item.name,
        defaultChecked: active
      },
      onChange: apply,
      disabled: disabled,
      label: /*#__PURE__*/React__namespace.createElement(FilterMenuItem, _extends$1({
        active: active,
        disabled: disabled
      }, item))
    })));
  }));
});

const filterClear = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__namespace.createElement("button", _extends$1({
    type: "button"
  }, props), children);
};

const filterMenu = ({
  children
}) => /*#__PURE__*/React__namespace.createElement("div", null, children);

const filterMenuItem = ({
  name,
  count
}) => /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, name, " (", count, ")");

SearchFilterMenu.defaultProps = {
  heading: null,
  filterClear: filterClear,
  filterMenu: filterMenu,
  filterMenuItem: filterMenuItem
};

const {
  QUERY_KEY,
  PAGER_KEY,
  OPTIONS
} = SEARCH_CONFIG;
const {
  GLOBAL: {
    CLEAR_ALL_LABEL,
    LOAD_MORE_LABEL,
    SUBMIT_LABEL,
    ARIASUBMIT_LABEL,
    SEARCH_LABEL,
    SEARCH_PLACEHOLDER,
    SEARCH_MESSAGE,
    SEARCH_NO_RESULTS_MESSAGE,
    SEARCH_ERROR_MESSAGE
  }
} = searchStrings;

const Search = ({
  defaultQuery,
  config,
  type,
  size,
  pagerType,
  initialData,
  onSubmit,
  endpoint,
  dataKey,
  strings,
  dataOnLoad,
  method,
  authHeader,
  adaptor,
  className,
  children,
  dataItemKey,
  onUpdateCallback,
  filters: propFilters,
  sort: propSort
}) => {
  /**
   * Calculate initial currentPage based on required
   * dataset size and any provided initialData.
   */
  const initCurrentPage = initialData && initialData.length > 0 ? Math.floor(Object.keys(initialData).length / size) - 1 : 0;
  const initialState = {
    data: initialData,
    total: 0,
    isPaging: false,
    currentPage: initCurrentPage,
    currentMessage: strings.message,
    loading: false,
    query: defaultQuery,
    pagerInView: false,
    filters: propFilters || {},
    sort: propSort
  };
  const [{
    data,
    total,
    isPaging,
    currentPage,
    currentMessage,
    loading,
    query,
    pagerInView,
    filters,
    sort
  }, setState] = React__namespace.useState(initialState);
  const [appliedFilters, setAppliedFilters] = React__namespace.useState({});

  const search = async (endpointT, dataKeyT, queryT, configT, isPagingT, stringsT, methodT, authHeaderT, adaptorT, appliedFiltersT, sortT) => {
    try {
      const result = await searchFetchData(endpointT, dataKeyT, queryT, configT, stringsT, methodT, authHeaderT, adaptorT, appliedFiltersT, sortT);

      if (!result || !result.data) {
        throw result;
      }
      /** Use FetchData returned from API to update Search states. */


      if (result.data) {
        const {
          message,
          total: rTotal
        } = result;
        /** Setup data array with any initial data. */

        let nData = [...initialData];
        /** Spread data in current dataset if infinite scrolling pager. */

        if (pagerType === 'infinite') {
          nData = [...nData, ...data];
        }
        /** Add results data in later for ordering. */


        nData = [...nData, ...result.data];
        const newData = getUnique(nData, dataItemKey);
        setState(prevState => ({ ...prevState,
          isPaging: false,
          loading: false,
          data: newData,
          currentMessage: message,
          total: rTotal,
          pagerInView: true,
          filters: result.filters
        }));

        if (onUpdateCallback) {
          onUpdateCallback(newData);
        }
      }
    } catch (error) {
      setState(prevState => ({ ...prevState,
        currentMessage: error.statusText || strings.searchErrorMessage
      }));
    }
  };
  /**
   * Throttle API request logic and response handling.
   * This is useful when functions are executed via user interaction.
   */


  const throttledSearch = React__namespace.useRef(debounce(search, SEARCH_THROTTLE_PERIOD)).current;
  let listener;
  /** Preserve the initial state in a new object. */

  React__namespace.useEffect(() => {
    /** Set default page 1 on page load to get first set of results. */
    if (pagerType === SEARCH_PAGER_TYPE_INFINITE) {
      const {
        pager
      } = config;
      searchUpdateQuery({
        [pager]: null
      }, {
        config,
        type
      });
    }
    /** Check querystring on initial page load, pass in BOOL to flag initial mount. */
    // eslint-disable-next-line no-use-before-define


    handleQueryChange();
    /** Listen for changes to the current location. */

    listener = history.listen(() => {
      /** Trigger query history change. */
      // eslint-disable-next-line no-use-before-define
      handleQueryChange();
    });
    return () => {
      listener();
    };
  }, []); // Handle query changes.

  React__namespace.useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    handleQueryChange();
  }, [appliedFilters, propSort]);
  React__namespace.useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    handleQueryChange();
  }, [query]);
  /**
   * Search form submit handler.
   *
   * @param {object} event
   */

  const handleSubmit = event => {
    event.preventDefault();

    if (!onSubmit) {
      return;
    }

    onSubmit(event);
  };
  /**
   * Reset state back to default and trigger callback.
   */


  const resetState = () => {
    setState({ ...initialState
    }); // HandleQueryChange();
  };
  /**
   * Resets the check boolean.
   */


  const resetPagerInView = () => setState(prevState => ({ ...prevState,
    pagerInView: false
  }));
  /**
   * Component callback handler for `hidden` Search type.
   *
   * @param {any} updatedQuery
   * @param {any} [pagination=null]
   * @param {boolean} [reset=false]
   * @returns {*}
   * @memberof Search
   */


  const setQueryHandler = (updatedQuery, pagination = null, reset = false) => {
    /** If no query catch and return. */
    if (!updatedQuery) {
      return null;
    }
    /** Reset state back to defaults and update render. */


    if (reset) {
      resetState();
      return null;
    }
    /**
     * Check if new query has length and instantiate a new object with query,
     * else just use new query. Applicable when deleting text input.
     */


    const sQuery = Object.keys(updatedQuery).length === 0 ? updatedQuery : { ...query,
      ...updatedQuery
    };
    /** Check this is not a pagination update.  */

    if (!pagination) {
      const {
        pager
      } = config;
      const resetQueryPage = { ...sQuery,
        [pager]: 1
      };
      setState(prevState => ({ ...prevState,
        query: resetQueryPage
      })); // HandleQueryChange();

      return resetQueryPage;
    }
    /** If search type is hidden, trigger query update via handleQueryChange. */


    const {
      loading: isLoading,
      value
    } = pagination;
    setState(prevState => ({ ...prevState,
      query: sQuery,
      isPaging: isLoading,
      currentPage: value
    }));
    /** NB: handle with useEffect everywhere? 
    If (
      type === SEARCH_TYPE_HIDDEN ||
      pagerType === SEARCH_PAGER_TYPE_INFINITE
    ) {
      console.info('DEBUG: SEARCH_TYPE_HIDDEN', SEARCH_TYPE_HIDDEN);
      // HandleQueryChange();
    }.
    */

    if (type === SEARCH_TYPE_EXPOSED) {
      /** Trigger query update via searchUpdateQuery. */
      const context = {
        config,
        type
      }; // NB: testing without bindSearchUpdateQuery

      searchUpdateQuery(updatedQuery, context);
    }

    return query;
  };
  /**
   * Handle and trigger API query changes from all Search components.
   *
   * @returns {bool}
   * @memberof Search
   */


  const handleQueryChange = () => {
    /**
     * Query to be used in the fetch.
     */
    const fetchQuery = type === SEARCH_TYPE_EXPOSED ? searchGetQuery(config) : query;
    /**
     * Do not use `Loading` state for pagination actions.
     * Do not set `Loading` state on page load if no args/query to do.
     */

    if (!isPaging && fetchQuery && Object.keys(fetchQuery).length > 0 || dataOnLoad) {
      setState(prevState => {
        return { ...prevState,
          loading: !(initialData && initialData.length > 0),
          fetch: fetchQuery,
          data: initialData
        };
      });
    }
    /* Reset component state if query is empty. 
    if (fetchQuery && Object.keys(fetchQuery).length === 0) {
      setState({ ...initialState });
    }.
    */


    if (fetchQuery && Object.keys(fetchQuery).length !== 0 || dataOnLoad) {
      const updatedQuery = {
        size,
        ...fetchQuery
      };
      const sortToUse = propSort || sort;
      /** Fetch data using Search component props values. */

      throttledSearch(endpoint, dataKey, updatedQuery, config, isPaging, strings, method, authHeader, adaptor, appliedFilters, sortToUse);
    }

    return true;
  };
  /**
   * Clears all applied filters and fetches new data.
   */


  const clearFilters = () => {
    // SetState((prevState) => ({
    //   ...prevState,
    //   AppliedFilters: {},
    // }));
    setAppliedFilters({});
  };
  /**
   * Removes a key from an object.
   *
   * @param {object} all - Current object.
   * @param {string} key - Key to remove.
   * @returns {object} - New object.
   */


  const removeFilterGroup = (all, key) => {
    const {
      [key]: removedGroup,
      ...remaining
    } = all;
    console.info('removedGroup', removedGroup);
    return { ...remaining
    };
  };
  /**
   * Clears a specific filter group and fetches new data.
   *
   * @param {string} filterName - The filter group name.
   */


  const clearFilterGroup = filterName => {
    // SetState((prevState) => ({
    //   ...prevState,
    //   AppliedFilters: removeFilterGroup(prevState.appliedFilters, filterName),
    // }));
    setAppliedFilters(prevState => removeFilterGroup(prevState, filterName));
  };
  /**
   * Applies a filter and fetches new data.
   *
   * @param {object} event
   * @param {string} filterName - The filter group name.
   */


  const applyFilter = (event, filterName) => {
    const {
      checked,
      value
    } = event.target;
    setAppliedFilters(prevState => {
      let current = [];
      /** Removes any filters currently active if the filter type was it un-check. */

      if (prevState[filterName]) {
        current = prevState[filterName].filter(item => {
          if (item !== value) return item;
          return false;
        });
      }
      /** Adds the filters if it was checked. */


      if (checked) {
        current.push(value);
      }
      /** If all the filters were removed we remove the group. */


      if (current.length === 0) {
        return removeFilterGroup(prevState, filterName);
      }

      return { ...prevState,
        [filterName]: current
      };
    }); // HandleQueryChange();
  };

  const context = {
    // FROM STATE.
    data: data,
    total: total,
    isPaging: isPaging,
    currentPage: currentPage,
    message: currentMessage,
    loading: loading,
    query: query,
    pagerInView: pagerInView,
    appliedFilters: appliedFilters,
    filters: filters,
    sort: sort,
    // FROM PROPS.
    size: size,
    config: config,
    type: type,
    pagerType: pagerType,
    // COMPONENT FUNCS.
    resetPagerInView: resetPagerInView,
    fetch: setQueryHandler,
    clearFilters: clearFilters,
    clearFilterGroup: clearFilterGroup,
    applyFilter: applyFilter
  };
  return /*#__PURE__*/React__namespace.createElement(SearchContext.Provider, {
    value: context
  }, /*#__PURE__*/React__namespace.createElement(Form, {
    submit: strings.submitLabel,
    ariaSubmitLabel: strings.ariaSubmitLabel,
    onSubmit: handleSubmit,
    hideSubmit: true,
    className: cx__default["default"]('search', className),
    submitID: "search-submit"
  }, children));
};

Search.defaultProps = {
  onSubmit: null,
  strings: {
    clearAllLabel: CLEAR_ALL_LABEL,
    loadMoreLabel: LOAD_MORE_LABEL,
    submitLabel: SUBMIT_LABEL,
    ariaSubmitLabel: ARIASUBMIT_LABEL,
    searchLabel: SEARCH_LABEL,
    searchPlaceholder: SEARCH_PLACEHOLDER,
    message: SEARCH_MESSAGE,
    searchNoResultsMessage: SEARCH_NO_RESULTS_MESSAGE,
    searchErrorMessage: SEARCH_ERROR_MESSAGE
  },
  size: SEARCH_RESULTS_SIZE,
  children: null,
  config: {
    search: QUERY_KEY,
    pager: PAGER_KEY,
    filters: null,
    options: OPTIONS
  },
  type: SEARCH_TYPE_EXPOSED,
  pagerType: SEARCH_PAGER_TYPE,
  defaultQuery: null,
  dataOnLoad: false,
  onUpdateCallback: null,
  method: 'POST',
  initialData: null,
  authHeader: null,
  adaptor: null,
  filters: null,
  sort: null
}; // @component ./SearchCount.js

Search.Count = SearchCount; // @component ./SearchData.js

Search.Data = SearchData; // @component ./SearchInput.js

Search.Input = SearchInput; // @component ./SearchLoader.js

Search.Loader = SearchLoader; // @component ./SearchMessage.js

Search.Message = SearchMessage; // @component ./SearchPagination.js

Search.Pagination = SearchPagination; // @component ./SearchReset.js

Search.Reset = SearchReset; // @component ./SearchResultsItems.js

Search.ResultsItems = SearchResultsItems; // @component ./SearchResultsList.js

Search.ResultsList = SearchResultsList; // @component ./SearchFilterMenu.js

Search.SearchFilterMenu = SearchFilterMenu;

var styles$6 = {"hidden":"Drawer-module_hidden__GaCMn","drawer":"Drawer-module_drawer__UiV-M","drawer--bottom":"Drawer-module_drawer--bottom__Z55ti","drawer--top":"Drawer-module_drawer--top__ae5-D","drawer--right":"Drawer-module_drawer--right__txHbR","drawer--left":"Drawer-module_drawer--left__D2Os6","animated":"Drawer-module_animated__EDHHf","infinite":"Drawer-module_infinite__Jfrjs","hinge":"Drawer-module_hinge__qVviZ","flip-out-x":"Drawer-module_flip-out-x__W6nfW","flip-out-y":"Drawer-module_flip-out-y__tM4d6","bounce-in":"Drawer-module_bounce-in__8V2hk","bounce-out":"Drawer-module_bounce-out__w34EO","bounce":"Drawer-module_bounce__5ulUj","flash":"Drawer-module_flash__GNMkb","pulse":"Drawer-module_pulse__5dGBy","rubber-band":"Drawer-module_rubber-band__Hdpql","shake":"Drawer-module_shake__KDt8v","head-shake":"Drawer-module_head-shake__0gXG-","swing":"Drawer-module_swing__3O8kO","tada":"Drawer-module_tada__98tGp","wobble":"Drawer-module_wobble__kdFnv","jello":"Drawer-module_jello__QCnmI","bounce-in-down":"Drawer-module_bounce-in-down__rKQxK","bounce-in-left":"Drawer-module_bounce-in-left__4-x2O","bounce-in-right":"Drawer-module_bounce-in-right__AqI31","bounce-in-up":"Drawer-module_bounce-in-up__geeOY","bounce-out-down":"Drawer-module_bounce-out-down__gzZWS","bounce-out-left":"Drawer-module_bounce-out-left__ERxpS","bounce-out-right":"Drawer-module_bounce-out-right__-VhlO","bounce-out-up":"Drawer-module_bounce-out-up__NQ1zH","fade-in":"Drawer-module_fade-in__dVfU6","fade-in-down":"Drawer-module_fade-in-down__Stb2k","fade-in-down-big":"Drawer-module_fade-in-down-big__l-zBU","fade-in-left":"Drawer-module_fade-in-left__RO61K","fade-in-left-big":"Drawer-module_fade-in-left-big__fqObi","fade-in-right":"Drawer-module_fade-in-right__XcBu3","fade-in-right-big":"Drawer-module_fade-in-right-big__crLM5","fade-in-up":"Drawer-module_fade-in-up__ol00O","fade-in-up50":"Drawer-module_fade-in-up50__-7LFU","fade-in-up-big":"Drawer-module_fade-in-up-big__2Q8fp","fade-out":"Drawer-module_fade-out__KYyWT","fade-out-down":"Drawer-module_fade-out-down__dCCmt","fade-out-down-big":"Drawer-module_fade-out-down-big__GTXu9","fade-out-left":"Drawer-module_fade-out-left__mIpL6","fade-out-left-big":"Drawer-module_fade-out-left-big__nnZgG","fade-out-right":"Drawer-module_fade-out-right__Ezlw-","fade-out-right-big":"Drawer-module_fade-out-right-big__8kV-c","fade-out-up":"Drawer-module_fade-out-up__vfqLW","fade-out-up-big":"Drawer-module_fade-out-up-big__tEY8S","flip":"Drawer-module_flip__nbaYc","flip-in-x":"Drawer-module_flip-in-x__8-gfy","flip-in-y":"Drawer-module_flip-in-y__bws1H","light-speed-in":"Drawer-module_light-speed-in__IwVfL","light-speed-out":"Drawer-module_light-speed-out__oyjAf","rotate-in":"Drawer-module_rotate-in__M4Wye","rotate-in-down-left":"Drawer-module_rotate-in-down-left__-hNNS","rotate-in-down-right":"Drawer-module_rotate-in-down-right__5gIiY","rotate-in-up-left":"Drawer-module_rotate-in-up-left__FaslF","rotate-in-up-right":"Drawer-module_rotate-in-up-right__asju6","rotate-out":"Drawer-module_rotate-out__7efk3","rotate-out-down-left":"Drawer-module_rotate-out-down-left__pqHI3","rotate-out-down-right":"Drawer-module_rotate-out-down-right__LzzR-","rotate-out-up-left":"Drawer-module_rotate-out-up-left__EhsUn","rotate-out-up-right":"Drawer-module_rotate-out-up-right__JpS1F","jack-in-the-box":"Drawer-module_jack-in-the-box__oZdrs","roll-in":"Drawer-module_roll-in__kLNsi","roll-out":"Drawer-module_roll-out__wlN07","zoom-in":"Drawer-module_zoom-in__HO-ZM","zoom-in-down":"Drawer-module_zoom-in-down__r6DZ5","zoom-in-left":"Drawer-module_zoom-in-left__PwJUB","zoom-in-right":"Drawer-module_zoom-in-right__fqq-d","zoom-in-up":"Drawer-module_zoom-in-up__YpzyI","zoom-out":"Drawer-module_zoom-out__Gvz9r","zoom-out-down":"Drawer-module_zoom-out-down__li707","zoom-out-left":"Drawer-module_zoom-out-left__7zhQf","zoom-out-right":"Drawer-module_zoom-out-right__lqkIH","zoom-out-up":"Drawer-module_zoom-out-up__DJWyY","slide-in-down":"Drawer-module_slide-in-down__4uf3K","slide-in-left":"Drawer-module_slide-in-left__vpwtT","slide-in-right":"Drawer-module_slide-in-right__HKw5l","slide-in-up":"Drawer-module_slide-in-up__BAZ3D","slide-out-down":"Drawer-module_slide-out-down__-jz96","slide-out-left":"Drawer-module_slide-out-left__Isjai","slide-out-right":"Drawer-module_slide-out-right__Z-rZz","slide-out-up":"Drawer-module_slide-out-up__7gQAz"};

const Drawer = ({
  children,
  className,
  position,
  activeClass,
  inactiveClass,
  isOpen,
  onClose
}) => {
  const drawer = React__namespace.useRef();
  const [open, setOpen] = React__namespace.useState(false);
  const [hiddenDrawer, setHiddenDrawer] = React__namespace.useState(true);
  React__namespace.useEffect(() => {
    /** Animation complete callback. */
    function onAnimationEnded() {
      if (!open) {
        setHiddenDrawer(true);
      }
    }

    if (drawer.current) {
      drawer.current.addEventListener('animationend', onAnimationEnded);
    }

    return () => {
      /** Remove listener for window resizing activity. */
      if (drawer.current) {
        drawer.current.removeEventListener('animationend', onAnimationEnded);
      }
    };
  }, [isOpen, open, drawer]);
  React__namespace.useEffect(() => {
    setHiddenDrawer(false);

    if (isOpen) {
      onClose();
    }

    setOpen(isOpen);
  }, [isOpen]);
  const drawerClass = cx__default["default"](styles$6.drawer, styles$6[`drawer--${position}`], {
    [styles$6['hidden']]: hiddenDrawer
  }, {
    [styles$6[activeClass]]: open
  }, {
    [styles$6[inactiveClass]]: !open
  }, className);
  return /*#__PURE__*/React__namespace.createElement("div", null, /*#__PURE__*/React__namespace.createElement("div", {
    className: drawerClass,
    ref: drawer
  }, children));
};

Drawer.defaultProps = {
  isOpen: false,
  position: 'bottom',
  onClose: null,
  children: null,
  activeClass: '',
  inactiveClass: ''
};

var styles$5 = {"hamburger":"Hamburger-module_hamburger__EOtOn","hamburger__box":"Hamburger-module_hamburger__box__mybnG","hamburger__inner":"Hamburger-module_hamburger__inner__Xd9ZD","is-active":"Hamburger-module_is-active__irXXT","hamburger--3dx":"Hamburger-module_hamburger--3dx__Brl-f","hamburger--3dxy-r":"Hamburger-module_hamburger--3dxy-r__2Z0cU","hamburger--3dxy":"Hamburger-module_hamburger--3dxy__RS86C","hamburger--3dy-r":"Hamburger-module_hamburger--3dy-r__QYW0M","hamburger--3dy":"Hamburger-module_hamburger--3dy__s5EOw","hamburger--arrow-r":"Hamburger-module_hamburger--arrow-r__4bf-i","hamburger--arrow":"Hamburger-module_hamburger--arrow__AzGPM","hamburger--arrowalt-r":"Hamburger-module_hamburger--arrowalt-r__kogpz","hamburger--arrowalt":"Hamburger-module_hamburger--arrowalt__FFG22","hamburger--arrowturn-r":"Hamburger-module_hamburger--arrowturn-r__QjaLz","hamburger--arrowturn":"Hamburger-module_hamburger--arrowturn__ctZf7","hamburger--boring":"Hamburger-module_hamburger--boring__PdHDt","hamburger--collapse-r":"Hamburger-module_hamburger--collapse-r__zxo8Q","hamburger--collapse":"Hamburger-module_hamburger--collapse__-Bzil","hamburger--elastic-r":"Hamburger-module_hamburger--elastic-r__MhFvm","hamburger--elastic":"Hamburger-module_hamburger--elastic__EdHU5","hamburger--emphatic-r":"Hamburger-module_hamburger--emphatic-r__rVNTv","hamburger--emphatic":"Hamburger-module_hamburger--emphatic__QFRPX","hamburger--minus":"Hamburger-module_hamburger--minus__I2iYW","hamburger--slider-r":"Hamburger-module_hamburger--slider-r__DZtwR","hamburger--slider":"Hamburger-module_hamburger--slider__RN2Kw","hamburger--spin-r":"Hamburger-module_hamburger--spin-r__zsbUp","hamburger--spin":"Hamburger-module_hamburger--spin__mbbSu","hamburger--spring-r":"Hamburger-module_hamburger--spring-r__bljQW","hamburger--spring":"Hamburger-module_hamburger--spring__5VBs3","hamburger--squeeze":"Hamburger-module_hamburger--squeeze__GAfPM","hamburger--stand-r":"Hamburger-module_hamburger--stand-r__EOMWJ","hamburger--stand":"Hamburger-module_hamburger--stand__mXvVb","hamburger--vortex-r":"Hamburger-module_hamburger--vortex-r__ZIqoA","hamburger--vortex":"Hamburger-module_hamburger--vortex__E3Y-V"};

const Hamburger = ({
  open,
  onToggle,
  className,
  strings,
  type,
  ariaControls
}) => {
  const [isOpen, setOpen] = React__namespace.useState(false);
  React__namespace.useEffect(() => {
    if (open !== isOpen) {
      /** Callback for the hamburger toggling. */
      onToggle();
    }
  }, [open]);

  const performToggle = status => {
    setOpen(status);
    onToggle(status);
  };

  const toggleHamburger = () => {
    performToggle(!isOpen);
  };

  const checkKeycode = event => {
    event.stopPropagation();

    if (event.keyCode === 13) {
      performToggle(!open);
    }
  };

  const hamburgerClass = cx__default["default"](styles$5.hamburger, styles$5[`hamburger--${type}`], {
    [styles$5[`is-active`]]: isOpen
  }, className);
  const boxClass = cx__default["default"](styles$5.hamburger__box);
  const innerClass = cx__default["default"](styles$5.hamburger__inner);
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: hamburgerClass,
    tabIndex: "0",
    "aria-label": strings.label,
    role: "button"
    /**
     * TODO: Remove eslint disable after `eslint-plugin-jsx-a11y`
     * is updated from `6.1.0` and the following bug is resolved:
     * https://github.com/evcohen/eslint-plugin-jsx-a11y/pull/456.
     */
    ,
    "aria-controls": ariaControls,
    "aria-expanded": open,
    onClick: toggleHamburger,
    onKeyDown: checkKeycode
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: boxClass
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: innerClass
  })));
};

Hamburger.defaultProps = {
  open: null,
  type: 'spin',
  onToggle: () => {},
  strings: {
    label: 'Menu'
  },
  ariaControls: 'navigation'
};

var styles$4 = {"modal":"Modal-module_modal__Cdbn7","backdrop":"Modal-module_backdrop__11HZK","modal--default":"Modal-module_modal--default__2K8yM","modal--fullscreen":"Modal-module_modal--fullscreen__ADgmM"};

const Modal = ({
  className,
  bodyClass,
  children,
  handleHide,
  layout,
  showing,
  topLevel
}) => {
  const [isVisible, setIsVisible] = React__namespace.useState(false);
  const dialog = React__namespace.useRef();
  /**
   * Add `dialog-polyfill`.
   *
   * In a separate function as it needs to be called in multiple places
   * for apps that use SSR so the server cannot access `window`.
   */

  const addDialogPolyfill = () => {
    if (!window && (!dialog.current.show || !dialog.current.showModal) && process.env.BROWSER) {
      // eslint-disable-next-line global-require
      const dialogPolyfill = require('dialog-polyfill');

      dialogPolyfill.registerDialog(dialog.current);
    }
  };
  /**
   * Add/Remove class to the body.
   *
   * @param {boolean} status - Whether the class is set.
   * @param {string} classPassed - The body class.
   */


  const bodyScroll = (status, classPassed) => {
    const className = classPassed || bodyClass;
    if (!process.env.BROWSER) return;

    if (status) {
      var _document, _document$body;

      // Stop the page scroll.
      (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : _document$body.classList.add(className);
    } else {
      var _document2, _document2$body;

      // Re-allow page scroll.
      (_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$body = _document2.body) === null || _document2$body === void 0 ? void 0 : _document2$body.classList.remove(className);
    }
  };
  /**
   * Show the modal.
   */


  const show = () => {
    bodyScroll(true);

    if (topLevel) {
      dialog.current.showModal();
      return;
    }

    dialog.current.show();
  };
  /**
   * Hides the modal.
   */


  const hide = () => {
    /**
     * We need to check if the dialog has the `open` attribute still
     * as the `dialog-polyfill` is quicker than getting here.
     * Ref: https://github.com/GoogleChrome/dialog-polyfill/issues/149.
     */
    if (dialog.current.open) {
      dialog.current.close();
    }

    bodyScroll(false);
  };
  /**
   * Handle keyboard events.
   *
   * @param {func} event
   */


  const handleKeyEvent = event => {
    // Close the modal if the user hit's the escape key.
    if (event.keyCode === 27) {
      setIsVisible(false);
      hide(); // Trigger hide Callback.

      if (handleHide) {
        handleHide();
      }
    }
  };

  React__namespace.useEffect(() => {
    addDialogPolyfill(); // Listen to keyboard events.

    document.addEventListener('keydown', handleKeyEvent, false);

    if (showing) {
      show();
    } else {
      hide();
    }

    return () => {
      bodyScroll(false); // Destroy listening to keyboard events.

      document.removeEventListener('keydown', handleKeyEvent, false);
    };
  }, []);
  React__namespace.useEffect(() => {
    if (showing !== isVisible) {
      addDialogPolyfill();

      if (showing) {
        show();
      } else {
        hide();
      }
    }
  }, [showing, isVisible]);
  React__namespace.useEffect(() => {
    if (showing !== isVisible) {
      setIsVisible(showing);
    }
  }, [isVisible, showing]);
  const classes = cx__default["default"](styles$4.modal, className, {
    [styles$4[`modal--${layout}`]]: layout
  });
  return /*#__PURE__*/React__namespace.createElement("dialog", {
    className: classes,
    ref: dialog
  }, children);
};

Modal.defaultProps = {
  bodyClass: 'no-scroll',
  children: null,
  handleHide: null,
  layout: 'default',
  show: false,
  topLevel: true
};

var styles$3 = {"container":"Container-module_container__n-q6C","constrained--default":"Container-module_constrained--default__yG8X3","constrained--narrow":"Container-module_constrained--narrow__mKVTZ","constrained--small":"Container-module_constrained--small__WBSxb","none":"Container-module_none__JlhAr","atom":"Container-module_atom__9Bpmu","default":"Container-module_default__QU9ob","element":"Container-module_element__0KY3C","component":"Container-module_component__tFtyv","module":"Container-module_module__CDgrs"};

const Container = ({
  children,
  className,
  spacing,
  constrained
}) => {
  const classes = cx__default["default"](className, styles$3.container, {
    [cx__default["default"](styles$3[`container--${spacing}`])]: spacing,
    [cx__default["default"](styles$3[`constrained--${constrained}`])]: constrained
  });
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classes
  }, children);
};

Container.defaultProps = {
  spacing: null
};

var styles$2 = {"layout":"CopyLayout-module_layout__5JGug","content":"CopyLayout-module_content__nzjxc","wrapper":"CopyLayout-module_wrapper__VtPC5","flush":"CopyLayout-module_flush__bxiGf"};

const CopyLayout = ({
  children,
  className,
  childClass,
  flush
}) => /*#__PURE__*/React__namespace.createElement(Container, {
  className: cx__default["default"](styles$2.wrapper, className, {
    [styles$2.flush]: flush
  })
}, /*#__PURE__*/React__namespace.createElement("div", {
  className: styles$2.layout
}, /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"](styles$2.content, childClass)
}, children)));

CopyLayout.defaultProps = {
  childClass: null,
  flush: false
};

var styles$1 = {"container":"ContentPageLayout-module_container__3zDEk","none":"ContentPageLayout-module_none__mZo30","atom":"ContentPageLayout-module_atom__LL2fT","default":"ContentPageLayout-module_default__JtMyL","element":"ContentPageLayout-module_element__lYK3O","component":"ContentPageLayout-module_component__byiHO","module":"ContentPageLayout-module_module__U2zso","content":"ContentPageLayout-module_content__cuKnP","narrow":"ContentPageLayout-module_narrow__zG5uK"};

const ContentPageLayout = ({
  children,
  spacing,
  narrow,
  flush
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"]('root-content', styles$1.container, styles$1[spacing], {
    [styles$1.narrow]: narrow
  })
}, /*#__PURE__*/React__namespace.createElement(CopyLayout, {
  childClass: cx__default["default"]({
    [styles$1.content]: !flush
  })
}, children));

ContentPageLayout.defaultProps = {
  spacing: 'none',
  narrow: false,
  flush: false
};

var styles = {"layout":"ContentRowsLayout-module_layout__0ReZr","none":"ContentRowsLayout-module_none__X3ltX","atom":"ContentRowsLayout-module_atom__pT0HQ","default":"ContentRowsLayout-module_default__U5DEC","element":"ContentRowsLayout-module_element__bf590","component":"ContentRowsLayout-module_component__Hutwe","module":"ContentRowsLayout-module_module__Jvg0b","feature":"ContentRowsLayout-module_feature__taeMx"};

const ContentRowsLayout = ({
  className,
  children,
  size
}) => /*#__PURE__*/React__namespace.createElement("div", {
  className: cx__default["default"](styles.layout, styles[size], className)
}, children);

ContentRowsLayout.defaultProps = {
  size: 'default'
};

const PageChromeless = ({
  content
}) => /*#__PURE__*/React__namespace.createElement("div", null, content);

const PageDefault = ({
  header,
  main,
  footer
}) => /*#__PURE__*/React__namespace.createElement("div", null, header, main, footer);

const Region = ({
  children,
  className,
  tag: Tag,
  id
}) => {
  const classes = cx__default["default"]('region', className);
  return /*#__PURE__*/React__namespace.createElement(Tag, {
    id: id,
    className: classes
  }, children);
};

Region.defaultProps = {
  tag: 'div',
  id: null
};

const withHistory = (WrappedComponent, className) => {
  const History = ({
    children
  }) => {
    return /*#__PURE__*/React__namespace.createElement(WrappedComponent, {
      history: history,
      className: className
    }, children);
  };

  History.defaultProps = {
    children: null
  };
  return History;
};

const withLayout = WrappedComponent => {
  const Layout = ({
    children
  }) => /*#__PURE__*/React__namespace.createElement(WrappedComponent, null, children);

  Layout.defaultProps = {
    children: null
  };
  return Layout;
};

/**
 * Throttle function frequency.
 *
 * @param {Function} func
 * @param {number} limit
 *
 * @returns {Function}
 */
const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

const Account = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const AccountCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const AccountOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const AlertOctagon = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13,13H11V7H13M12,17.3A1.3,1.3 0 0,1 10.7,16A1.3,1.3 0 0,1 12,14.7A1.3,1.3 0 0,1 13.3,16A1.3,1.3 0 0,1 12,17.3M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const AlertCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const AlertOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const AutoRenew = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,6V9L16,5L12,1V4A8,8 0 0,0 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12A6,6 0 0,1 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12A6,6 0 0,1 12,18V15L8,19L12,23V20A8,8 0 0,0 20,12C20,10.43 19.54,8.97 18.76,7.74Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ArrowDown = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ArrowLeft = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ArrowRight = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ArrowUp = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Calendar = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarBlank = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarCheck = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M16.53,11.06L15.47,10L10.59,14.88L8.47,12.76L7.41,13.82L10.59,17L16.53,11.06Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarClock = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarMultiple = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21,17V8H7V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V5A2,2 0 0,1 7,3H8V1H10V3H18V1H20V3H21M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21M19,15H15V11H19V15Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarMultipleCheck = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21,17V8H7V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V5A2,2 0 0,1 7,3H8V1H10V3H18V1H20V3H21M17.53,11.06L13.09,15.5L10.41,12.82L11.47,11.76L13.09,13.38L16.47,10L17.53,11.06M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarPlus = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19V7H5V19H19M16,1H18V3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1M11,9H13V12H16V14H13V17H11V14H8V12H11V9Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarQuestion = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6,1V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H18V1H16V3H8V1H6M5,8H19V19H5V8M12.19,9C11.32,9 10.62,9.2 10.08,9.59C9.56,10 9.3,10.57 9.31,11.36L9.32,11.39H11.25C11.26,11.09 11.35,10.86 11.53,10.7C11.71,10.55 11.93,10.47 12.19,10.47C12.5,10.47 12.76,10.57 12.94,10.75C13.12,10.94 13.2,11.2 13.2,11.5C13.2,11.82 13.13,12.09 12.97,12.32C12.83,12.55 12.62,12.75 12.36,12.91C11.85,13.25 11.5,13.55 11.31,13.82C11.11,14.08 11,14.5 11,15H13C13,14.69 13.04,14.44 13.13,14.26C13.22,14.08 13.39,13.9 13.64,13.74C14.09,13.5 14.46,13.21 14.75,12.81C15.04,12.41 15.19,12 15.19,11.5C15.19,10.74 14.92,10.13 14.38,9.68C13.85,9.23 13.12,9 12.19,9M11,16V18H13V16H11Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarRange = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9,10H7V12H9V10M13,10H11V12H13V10M17,10H15V12H17V10M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarRemove = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M9.31,17L11.75,14.56L14.19,17L15.25,15.94L12.81,13.5L15.25,11.06L14.19,10L11.75,12.44L9.31,10L8.25,11.06L10.69,13.5L8.25,15.94L9.31,17Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarText = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14,14H7V16H14M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M17,10H7V12H17V10Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CalendarToday = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Cancel = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20A8,8 0 0,0 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CellphoneIphone = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16,18H7V4H16M11.5,22A1.5,1.5 0 0,1 10,20.5A1.5,1.5 0 0,1 11.5,19A1.5,1.5 0 0,1 13,20.5A1.5,1.5 0 0,1 11.5,22M15.5,1H7.5A2.5,2.5 0 0,0 5,3.5V20.5A2.5,2.5 0 0,0 7.5,23H15.5A2.5,2.5 0 0,0 18,20.5V3.5A2.5,2.5 0 0,0 15.5,1Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Circle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Check = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CheckCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ChevronLeft = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ChevronRight = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ChevronUp = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Close = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const CloseCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ContentBox = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Delete = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const DeleteEmpty = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.37,8.91L19.37,10.64L7.24,3.64L8.24,1.91L11.28,3.66L12.64,3.29L16.97,5.79L17.34,7.16L20.37,8.91M6,19V7H11.07L18,11V19A2,2 0 0,1 16,21H8A2,2 0 0,1 6,19Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const DiceMultiple = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.78,3H11.22C10.55,3 10,3.55 10,4.22V8H16V14H19.78C20.45,14 21,13.45 21,12.78V4.22C21,3.55 20.45,3 19.78,3M12.44,6.67C11.76,6.67 11.21,6.12 11.21,5.44C11.21,4.76 11.76,4.21 12.44,4.21A1.23,1.23 0 0,1 13.67,5.44C13.67,6.12 13.12,6.67 12.44,6.67M18.56,12.78C17.88,12.79 17.33,12.24 17.32,11.56C17.31,10.88 17.86,10.33 18.54,10.32C19.22,10.31 19.77,10.86 19.78,11.56C19.77,12.23 19.23,12.77 18.56,12.78M18.56,6.67C17.88,6.68 17.33,6.13 17.32,5.45C17.31,4.77 17.86,4.22 18.54,4.21C19.22,4.2 19.77,4.75 19.78,5.44C19.78,6.12 19.24,6.66 18.56,6.67M4.22,10H12.78A1.22,1.22 0 0,1 14,11.22V19.78C14,20.45 13.45,21 12.78,21H4.22C3.55,21 3,20.45 3,19.78V11.22C3,10.55 3.55,10 4.22,10M8.5,14.28C7.83,14.28 7.28,14.83 7.28,15.5C7.28,16.17 7.83,16.72 8.5,16.72C9.17,16.72 9.72,16.17 9.72,15.5A1.22,1.22 0 0,0 8.5,14.28M5.44,11.22C4.77,11.22 4.22,11.77 4.22,12.44A1.22,1.22 0 0,0 5.44,13.66C6.11,13.66 6.66,13.11 6.66,12.44V12.44C6.66,11.77 6.11,11.22 5.44,11.22M11.55,17.33C10.88,17.33 10.33,17.88 10.33,18.55C10.33,19.22 10.88,19.77 11.55,19.77A1.22,1.22 0 0,0 12.77,18.55H12.77C12.77,17.88 12.23,17.34 11.56,17.33H11.55Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Email = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Eye = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const EyeOff = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Fitness = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Google = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Heart = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const HeartOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const HeartOff = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1,4.27L2.28,3L20,20.72L18.73,22L15.18,18.44L13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,7.55 2.23,6.67 2.63,5.9L1,4.27M7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,11.07 20.42,13.32 17.79,15.97L5.27,3.45C5.95,3.16 6.7,3 7.5,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const HelpCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const House = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Instagram = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const LeadPencil = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const LinkVariant = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const LinkVariantOff = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2,5.27L3.28,4L20,20.72L18.73,22L13.9,17.17L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L12.5,15.76L10.88,14.15C10.87,14.39 10.77,14.64 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C8.12,13.77 7.63,12.37 7.72,11L2,5.27M12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.79,8.97L9.38,7.55L12.71,4.22M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.2,10.54 16.61,12.5 16.06,14.23L14.28,12.46C14.23,11.78 13.94,11.11 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Magnify = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const MinusCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Play = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8,5.14V19.14L19,12.14L8,5.14Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const PlayCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const PauseCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15,16H13V8H15M11,16H9V8H11M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Pencil = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const PencilCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M15.1,7.07C15.24,7.07 15.38,7.12 15.5,7.23L16.77,8.5C17,8.72 17,9.07 16.77,9.28L15.77,10.28L13.72,8.23L14.72,7.23C14.82,7.12 14.96,7.07 15.1,7.07M13.13,8.81L15.19,10.87L9.13,16.93H7.07V14.87L13.13,8.81Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Plus = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const PlusBox = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const PlusBoxOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const PlusCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const MapMarker = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Message = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const MessageOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H6L4,18V4H20"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Minus = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,13H5V11H19V13Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const MinusBox = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const MinusBoxOutline = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M17,11V13H7V11H17Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Reload = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19,12H22.32L17.37,16.95L12.42,12H16.97C17,10.46 16.42,8.93 15.24,7.75C12.9,5.41 9.1,5.41 6.76,7.75C4.42,10.09 4.42,13.9 6.76,16.24C8.6,18.08 11.36,18.47 13.58,17.41L15.05,18.88C12,20.69 8,20.29 5.34,17.65C2.22,14.53 2.23,9.47 5.35,6.35C8.5,3.22 13.53,3.21 16.66,6.34C18.22,7.9 19,9.95 19,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const RemoveShoppingCart = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zM20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Replay = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const ShoppingCart = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const SkipNext = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8L13,12L8,16M14,8H16V16H14"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const SkipNextCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8L13,12L8,16M14,8H16V16H14"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const SkipPrevious = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const SkipPreviousCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8H10V16H8M16,8V16L11,12"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const StopCircle = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M9,9H15V15H9"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const SwapHorizontal = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const SwapVertical = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Upload = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Video = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumeHigh = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumeLow = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7,9V15H11L16,20V4L11,9H7Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumeMedium = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5,9V15H9L14,20V4L9,9M18.5,12C18.5,10.23 17.5,8.71 16,7.97V16C17.5,15.29 18.5,13.76 18.5,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumeMinus = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3,9H7L12,4V20L7,15H3V9M14,11H22V13H14V11Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumeMute = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3,9H7L12,4V20L7,15H3V9M16.59,12L14,9.41L15.41,8L18,10.59L20.59,8L22,9.41L19.41,12L22,14.59L20.59,16L18,13.41L15.41,16L14,14.59L16.59,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumeOff = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const VolumePlus = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3,9H7L12,4V20L7,15H3V9M14,11H17V8H19V11H22V13H19V16H17V13H14V11Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Warning = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

const Youtube = props => {
  const icon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
  }), props)();
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, icon);
};

exports.Abbr = Abbr;
exports.Account = Account;
exports.AccountCircle = AccountCircle;
exports.AccountOutline = AccountOutline;
exports.AlertCircle = AlertCircle;
exports.AlertOctagon = AlertOctagon;
exports.AlertOutline = AlertOutline;
exports.ArrowDown = ArrowDown;
exports.ArrowLeft = ArrowLeft;
exports.ArrowRight = ArrowRight;
exports.ArrowUp = ArrowUp;
exports.AspectRatio = AspectRatio;
exports.AutoRenew = AutoRenew;
exports.Button = Button;
exports.ButtonGroup = ButtonGroup;
exports.Calendar = Calendar;
exports.CalendarBlank = CalendarBlank;
exports.CalendarCheck = CalendarCheck;
exports.CalendarClock = CalendarClock;
exports.CalendarMultiple = CalendarMultiple;
exports.CalendarMultipleCheck = CalendarMultipleCheck;
exports.CalendarPlus = CalendarPlus;
exports.CalendarQuestion = CalendarQuestion;
exports.CalendarRange = CalendarRange;
exports.CalendarRemove = CalendarRemove;
exports.CalendarText = CalendarText;
exports.CalendarToday = CalendarToday;
exports.Cancel = Cancel;
exports.Card = Card;
exports.CellphoneIphone = CellphoneIphone;
exports.Check = Check;
exports.CheckCircle = CheckCircle;
exports.ChevronDown = ChevronDown;
exports.ChevronLeft = ChevronLeft;
exports.ChevronRight = ChevronRight;
exports.ChevronUp = ChevronUp;
exports.Circle = Circle;
exports.Close = Close;
exports.CloseCircle = CloseCircle;
exports.Container = Container;
exports.ContentBox = ContentBox;
exports.ContentPageLayout = ContentPageLayout;
exports.ContentRowsLayout = ContentRowsLayout;
exports.Copy = Copy;
exports.CopyLayout = CopyLayout;
exports.Cover = Cover;
exports.Delete = Delete;
exports.DeleteEmpty = DeleteEmpty;
exports.DiceMultiple = DiceMultiple;
exports.Drawer = Drawer;
exports.Email = Email;
exports.Eye = Eye;
exports.EyeOff = EyeOff;
exports.EyeOutline = EyeOutline;
exports.EyeoffOutline = EyeoffOutline;
exports.FacebookBox = FacebookBox;
exports.Fitness = Fitness;
exports.Form = Form;
exports.FormField = FormField;
exports.FormInput = FormInput;
exports.FormSelect = FormSelect;
exports.FormTextArea = FormTextArea;
exports.Google = Google;
exports.Grid = Grid;
exports.Hamburger = Hamburger;
exports.Heading = Heading;
exports.Heart = Heart;
exports.HeartOff = HeartOff;
exports.HeartOutline = HeartOutline;
exports.HelpCircle = HelpCircle;
exports.House = House;
exports.Icon = Icon;
exports.Image = Image;
exports.Instagram = Instagram;
exports.LeadPencil = LeadPencil;
exports.Link = Link;
exports.LinkVariant = LinkVariant;
exports.LinkVariantOff = LinkVariantOff;
exports.List = List;
exports.ListItem = ListItem;
exports.Loader = Loader;
exports.Magnify = Magnify;
exports.MapMarker = MapMarker;
exports.Message = Message;
exports.MessageOutline = MessageOutline;
exports.Minus = Minus;
exports.MinusBox = MinusBox;
exports.MinusBoxOutline = MinusBoxOutline;
exports.MinusCircle = MinusCircle;
exports.Modal = Modal;
exports.PageChromeless = PageChromeless;
exports.PageDefault = PageDefault;
exports.PauseCircle = PauseCircle;
exports.Pencil = Pencil;
exports.PencilCircle = PencilCircle;
exports.Play = Play;
exports.PlayCircle = PlayCircle;
exports.Plus = Plus;
exports.PlusBox = PlusBox;
exports.PlusBoxOutline = PlusBoxOutline;
exports.PlusCircle = PlusCircle;
exports.Region = Region;
exports.Reload = Reload;
exports.RemoveShoppingCart = RemoveShoppingCart;
exports.Replay = Replay;
exports.ResponsiveImage = ResponsiveImage;
exports.Search = Search;
exports.SearchContext = SearchContext;
exports.Share = Share;
exports.ShoppingCart = ShoppingCart;
exports.SkipNext = SkipNext;
exports.SkipNextCircle = SkipNextCircle;
exports.SkipPrevious = SkipPrevious;
exports.SkipPreviousCircle = SkipPreviousCircle;
exports.SocialShare = SocialShare;
exports.StopCircle = StopCircle;
exports.SwapHorizontal = SwapHorizontal;
exports.SwapVertical = SwapVertical;
exports.Time = Time;
exports.Twitter = Twitter;
exports.Type = Type;
exports.Upload = Upload;
exports.Video = Video;
exports.VolumeHigh = VolumeHigh;
exports.VolumeLow = VolumeLow;
exports.VolumeMedium = VolumeMedium;
exports.VolumeMinus = VolumeMinus;
exports.VolumeMute = VolumeMute;
exports.VolumeOff = VolumeOff;
exports.VolumePlus = VolumePlus;
exports.Warning = Warning;
exports.Youtube = Youtube;
exports.debounce = debounce;
exports.history = history;
exports.throttle = throttle;
exports.withHistory = withHistory;
exports.withLayout = withLayout;
